"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step3;
    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  BLUR_EDITOR_EVENT: function BLUR_EDITOR_EVENT() {
    return _BLUR_EDITOR_EVENT;
  },
  CARRIAGE_RETURN: function CARRIAGE_RETURN() {
    return _CARRIAGE_RETURN;
  },
  DOM_HANDLERS: function DOM_HANDLERS() {
    return _DOM_HANDLERS;
  },
  DefaultLeaf: function DefaultLeaf() {
    return _DefaultLeaf;
  },
  ELEMENT_DEFAULT: function ELEMENT_DEFAULT() {
    return _ELEMENT_DEFAULT;
  },
  EXPOSED_STORE_KEYS: function EXPOSED_STORE_KEYS() {
    return _EXPOSED_STORE_KEYS;
  },
  EditorMethodsEffect: function EditorMethodsEffect() {
    return _EditorMethodsEffect;
  },
  EditorRefEffect: function EditorRefEffect() {
    return _EditorRefEffect;
  },
  EditorRefPluginEffect: function EditorRefPluginEffect() {
    return _EditorRefPluginEffect;
  },
  EditorStateEffect: function EditorStateEffect() {
    return _EditorStateEffect;
  },
  ElementProvider: function ElementProvider() {
    return _ElementProvider;
  },
  FOCUS_EDITOR_EVENT: function FOCUS_EDITOR_EVENT() {
    return _FOCUS_EDITOR_EVENT;
  },
  GLOBAL_PLATE_SCOPE: function GLOBAL_PLATE_SCOPE() {
    return _GLOBAL_PLATE_SCOPE;
  },
  Hotkeys: function Hotkeys() {
    return _Hotkeys;
  },
  KEY_DESERIALIZE_AST: function KEY_DESERIALIZE_AST() {
    return _KEY_DESERIALIZE_AST;
  },
  KEY_DESERIALIZE_HTML: function KEY_DESERIALIZE_HTML() {
    return _KEY_DESERIALIZE_HTML;
  },
  KEY_EDITOR_PROTOCOL: function KEY_EDITOR_PROTOCOL() {
    return _KEY_EDITOR_PROTOCOL;
  },
  KEY_EVENT_EDITOR: function KEY_EVENT_EDITOR() {
    return _KEY_EVENT_EDITOR;
  },
  KEY_HISTORY: function KEY_HISTORY() {
    return _KEY_HISTORY;
  },
  KEY_INLINE_VOID: function KEY_INLINE_VOID() {
    return _KEY_INLINE_VOID;
  },
  KEY_INSERT_DATA: function KEY_INSERT_DATA() {
    return _KEY_INSERT_DATA;
  },
  KEY_LENGTH: function KEY_LENGTH() {
    return _KEY_LENGTH;
  },
  KEY_NODE_FACTORY: function KEY_NODE_FACTORY() {
    return _KEY_NODE_FACTORY;
  },
  KEY_PREV_SELECTION: function KEY_PREV_SELECTION() {
    return _KEY_PREV_SELECTION;
  },
  KEY_REACT: function KEY_REACT() {
    return _KEY_REACT;
  },
  LINE_FEED: function LINE_FEED() {
    return _LINE_FEED;
  },
  NO_BREAK_SPACE: function NO_BREAK_SPACE() {
    return _NO_BREAK_SPACE;
  },
  PLATE_SCOPE: function PLATE_SCOPE() {
    return _PLATE_SCOPE;
  },
  Plate: function Plate() {
    return _Plate;
  },
  PlateContent: function PlateContent() {
    return _PlateContent;
  },
  PlateController: function PlateController() {
    return _PlateController;
  },
  PlateControllerEffect: function PlateControllerEffect() {
    return _PlateControllerEffect;
  },
  PlateEffects: function PlateEffects() {
    return _PlateEffects;
  },
  PlateSlate: function PlateSlate() {
    return _PlateSlate;
  },
  PlateStoreProvider: function PlateStoreProvider() {
    return _PlateStoreProvider;
  },
  PlateTest: function PlateTest() {
    return _PlateTest;
  },
  SCOPE_ELEMENT: function SCOPE_ELEMENT() {
    return _SCOPE_ELEMENT;
  },
  SPACE: function SPACE() {
    return _SPACE;
  },
  TAB: function TAB() {
    return _TAB;
  },
  ZERO_WIDTH_SPACE: function ZERO_WIDTH_SPACE() {
    return _ZERO_WIDTH_SPACE;
  },
  applyDeepToNodes: function applyDeepToNodes() {
    return _applyDeepToNodes2;
  },
  atom: function atom() {
    return import_jotai.atom;
  },
  cleanHtmlBrElements: function cleanHtmlBrElements() {
    return _cleanHtmlBrElements;
  },
  cleanHtmlCrLf: function cleanHtmlCrLf() {
    return _cleanHtmlCrLf;
  },
  cleanHtmlEmptyElements: function cleanHtmlEmptyElements() {
    return _cleanHtmlEmptyElements;
  },
  cleanHtmlFontElements: function cleanHtmlFontElements() {
    return _cleanHtmlFontElements;
  },
  cleanHtmlLinkElements: function cleanHtmlLinkElements() {
    return _cleanHtmlLinkElements;
  },
  cleanHtmlTextNodes: function cleanHtmlTextNodes() {
    return _cleanHtmlTextNodes;
  },
  collapseString: function collapseString() {
    return _collapseString;
  },
  collapseWhiteSpace: function collapseWhiteSpace() {
    return _collapseWhiteSpace;
  },
  collapseWhiteSpaceChildren: function collapseWhiteSpaceChildren() {
    return _collapseWhiteSpaceChildren;
  },
  collapseWhiteSpaceElement: function collapseWhiteSpaceElement() {
    return _collapseWhiteSpaceElement;
  },
  collapseWhiteSpaceNode: function collapseWhiteSpaceNode() {
    return _collapseWhiteSpaceNode;
  },
  collapseWhiteSpaceText: function collapseWhiteSpaceText() {
    return _collapseWhiteSpaceText;
  },
  convertDomEventToSyntheticEvent: function convertDomEventToSyntheticEvent() {
    return _convertDomEventToSyntheticEvent;
  },
  copyBlockMarksToSpanChild: function copyBlockMarksToSpanChild() {
    return _copyBlockMarksToSpanChild;
  },
  createAtomStore: function createAtomStore() {
    return import_jotai_x.createAtomStore;
  },
  createDeserializeAstPlugin: function createDeserializeAstPlugin() {
    return _createDeserializeAstPlugin;
  },
  createDeserializeHtmlPlugin: function createDeserializeHtmlPlugin() {
    return _createDeserializeHtmlPlugin;
  },
  createEditorProtocolPlugin: function createEditorProtocolPlugin() {
    return _createEditorProtocolPlugin;
  },
  createEventEditorPlugin: function createEventEditorPlugin() {
    return _createEventEditorPlugin;
  },
  createHistoryPlugin: function createHistoryPlugin() {
    return _createHistoryPlugin;
  },
  createHotkey: function createHotkey() {
    return _createHotkey;
  },
  createInlineVoidPlugin: function createInlineVoidPlugin() {
    return _createInlineVoidPlugin;
  },
  createInsertDataPlugin: function createInsertDataPlugin() {
    return _createInsertDataPlugin;
  },
  createLengthPlugin: function createLengthPlugin() {
    return _createLengthPlugin;
  },
  createNodeFactoryPlugin: function createNodeFactoryPlugin() {
    return _createNodeFactoryPlugin;
  },
  createPlateEditor: function createPlateEditor() {
    return _createPlateEditor;
  },
  createPlateFallbackEditor: function createPlateFallbackEditor() {
    return _createPlateFallbackEditor;
  },
  createPlateStore: function createPlateStore() {
    return _createPlateStore;
  },
  createPluginFactory: function createPluginFactory() {
    return _createPluginFactory;
  },
  createPlugins: function createPlugins() {
    return _createPlugins;
  },
  createPrevSelectionPlugin: function createPrevSelectionPlugin() {
    return _createPrevSelectionPlugin;
  },
  createReactPlugin: function createReactPlugin() {
    return _createReactPlugin;
  },
  createZustandStore: function createZustandStore() {
    return import_zustand_x.createZustandStore;
  },
  deserializeHtml: function deserializeHtml() {
    return _deserializeHtml;
  },
  deserializeHtmlElement: function deserializeHtmlElement() {
    return _deserializeHtmlElement;
  },
  deserializeHtmlNode: function deserializeHtmlNode() {
    return _deserializeHtmlNode;
  },
  deserializeHtmlNodeChildren: function deserializeHtmlNodeChildren() {
    return _deserializeHtmlNodeChildren;
  },
  endInlineFormattingContext: function endInlineFormattingContext() {
    return _endInlineFormattingContext;
  },
  eventEditorActions: function eventEditorActions() {
    return _eventEditorActions;
  },
  eventEditorSelectors: function eventEditorSelectors() {
    return _eventEditorSelectors;
  },
  eventEditorStore: function eventEditorStore() {
    return _eventEditorStore;
  },
  findHtmlElement: function findHtmlElement() {
    return _findHtmlElement;
  },
  flattenDeepPlugins: function flattenDeepPlugins() {
    return _flattenDeepPlugins2;
  },
  getEventPlateId: function getEventPlateId() {
    return _getEventPlateId;
  },
  getHtmlComments: function getHtmlComments() {
    return _getHtmlComments;
  },
  getInjectedPlugins: function getInjectedPlugins() {
    return _getInjectedPlugins;
  },
  getKeyByType: function getKeyByType() {
    return _getKeyByType;
  },
  getKeysByTypes: function getKeysByTypes() {
    return _getKeysByTypes;
  },
  getPlugin: function getPlugin() {
    return _getPlugin;
  },
  getPluginInjectProps: function getPluginInjectProps() {
    return _getPluginInjectProps;
  },
  getPluginOptions: function getPluginOptions() {
    return _getPluginOptions;
  },
  getPluginType: function getPluginType() {
    return _getPluginType;
  },
  getPluginTypes: function getPluginTypes() {
    return _getPluginTypes;
  },
  getPlugins: function getPlugins() {
    return _getPlugins;
  },
  getPluginsByKey: function getPluginsByKey() {
    return _getPluginsByKey;
  },
  getRenderNodeProps: function getRenderNodeProps() {
    return _getRenderNodeProps;
  },
  getSlateClass: function getSlateClass() {
    return _getSlateClass;
  },
  htmlBodyToFragment: function htmlBodyToFragment() {
    return _htmlBodyToFragment;
  },
  htmlBrToNewLine: function htmlBrToNewLine() {
    return _htmlBrToNewLine;
  },
  htmlElementToElement: function htmlElementToElement() {
    return _htmlElementToElement;
  },
  htmlElementToLeaf: function htmlElementToLeaf() {
    return _htmlElementToLeaf;
  },
  htmlStringToDOMNode: function htmlStringToDOMNode() {
    return _htmlStringToDOMNode;
  },
  htmlTextNodeToString: function htmlTextNodeToString() {
    return _htmlTextNodeToString;
  },
  inferWhiteSpaceRule: function inferWhiteSpaceRule() {
    return _inferWhiteSpaceRule;
  },
  inlineTagNames: function inlineTagNames() {
    return _inlineTagNames;
  },
  isEventHandled: function isEventHandled() {
    return _isEventHandled;
  },
  isHotkey: function isHotkey() {
    return import_is_hotkey2.isHotkey;
  },
  isHotkeyPressed: function isHotkeyPressed() {
    return import_react_hotkeys_hook.isHotkeyPressed;
  },
  isHtmlBlockElement: function isHtmlBlockElement() {
    return _isHtmlBlockElement;
  },
  isHtmlComment: function isHtmlComment() {
    return _isHtmlComment;
  },
  isHtmlElement: function isHtmlElement() {
    return _isHtmlElement;
  },
  isHtmlFragmentHref: function isHtmlFragmentHref() {
    return _isHtmlFragmentHref;
  },
  isHtmlInlineElement: function isHtmlInlineElement() {
    return _isHtmlInlineElement2;
  },
  isHtmlTable: function isHtmlTable() {
    return _isHtmlTable;
  },
  isHtmlText: function isHtmlText() {
    return _isHtmlText;
  },
  isLastNonEmptyTextOfInlineFormattingContext: function isLastNonEmptyTextOfInlineFormattingContext() {
    return _isLastNonEmptyTextOfInlineFormattingContext;
  },
  isOlSymbol: function isOlSymbol() {
    return _isOlSymbol;
  },
  mapInjectPropsToPlugin: function mapInjectPropsToPlugin() {
    return _mapInjectPropsToPlugin;
  },
  mergeDeepPlugins: function mergeDeepPlugins() {
    return _mergeDeepPlugins2;
  },
  mergeDeepToNodes: function mergeDeepToNodes() {
    return _mergeDeepToNodes;
  },
  mockPlugin: function mockPlugin() {
    return _mockPlugin;
  },
  nanoid: function nanoid() {
    return import_nanoid.nanoid;
  },
  normalizeDescendantsToDocumentFragment: function normalizeDescendantsToDocumentFragment() {
    return _normalizeDescendantsToDocumentFragment;
  },
  normalizeInitialValue: function normalizeInitialValue() {
    return _normalizeInitialValue;
  },
  overridePluginsByKey: function overridePluginsByKey() {
    return _overridePluginsByKey2;
  },
  parseHtmlDocument: function parseHtmlDocument() {
    return _parseHtmlDocument;
  },
  parseHtmlElement: function parseHtmlElement() {
    return _parseHtmlElement;
  },
  pipeDecorate: function pipeDecorate() {
    return _pipeDecorate;
  },
  pipeDeserializeHtmlElement: function pipeDeserializeHtmlElement() {
    return _pipeDeserializeHtmlElement;
  },
  pipeDeserializeHtmlLeaf: function pipeDeserializeHtmlLeaf() {
    return _pipeDeserializeHtmlLeaf;
  },
  pipeHandler: function pipeHandler() {
    return _pipeHandler;
  },
  pipeInjectProps: function pipeInjectProps() {
    return _pipeInjectProps;
  },
  pipeInsertDataQuery: function pipeInsertDataQuery() {
    return _pipeInsertDataQuery;
  },
  pipeInsertFragment: function pipeInsertFragment() {
    return _pipeInsertFragment;
  },
  pipeOnChange: function pipeOnChange() {
    return _pipeOnChange;
  },
  pipeRenderElement: function pipeRenderElement() {
    return _pipeRenderElement;
  },
  pipeRenderLeaf: function pipeRenderLeaf() {
    return _pipeRenderLeaf;
  },
  pipeTransformData: function pipeTransformData() {
    return _pipeTransformData;
  },
  pipeTransformFragment: function pipeTransformFragment() {
    return _pipeTransformFragment;
  },
  plateControllerStore: function plateControllerStore() {
    return _plateControllerStore;
  },
  plateStore: function plateStore() {
    return _plateStore;
  },
  pluginDeserializeHtml: function pluginDeserializeHtml() {
    return _pluginDeserializeHtml;
  },
  pluginInjectProps: function pluginInjectProps() {
    return _pluginInjectProps;
  },
  pluginRenderElement: function pluginRenderElement() {
    return _pluginRenderElement;
  },
  pluginRenderLeaf: function pluginRenderLeaf() {
    return _pluginRenderLeaf;
  },
  postCleanHtml: function postCleanHtml() {
    return _postCleanHtml;
  },
  preCleanHtml: function preCleanHtml() {
    return _preCleanHtml;
  },
  removeHtmlNodesBetweenComments: function removeHtmlNodesBetweenComments() {
    return _removeHtmlNodesBetweenComments;
  },
  removeHtmlSurroundings: function removeHtmlSurroundings() {
    return _removeHtmlSurroundings;
  },
  replaceTagName: function replaceTagName() {
    return _replaceTagName;
  },
  resetEditor: function resetEditor() {
    return _resetEditor;
  },
  resetEditorChildren: function resetEditorChildren() {
    return _resetEditorChildren;
  },
  setDefaultPlugin: function setDefaultPlugin() {
    return _setDefaultPlugin;
  },
  setPlatePlugins: function setPlatePlugins() {
    return _setPlatePlugins;
  },
  sharedHotkeys: function sharedHotkeys() {
    return _sharedHotkeys;
  },
  someHtmlElement: function someHtmlElement() {
    return _someHtmlElement;
  },
  toggleNodeType: function toggleNodeType() {
    return _toggleNodeType;
  },
  traverseHtmlComments: function traverseHtmlComments() {
    return _traverseHtmlComments;
  },
  traverseHtmlElements: function traverseHtmlElements() {
    return _traverseHtmlElements;
  },
  traverseHtmlNode: function traverseHtmlNode() {
    return _traverseHtmlNode2;
  },
  traverseHtmlTexts: function traverseHtmlTexts() {
    return _traverseHtmlTexts;
  },
  unwrapHtmlElement: function unwrapHtmlElement() {
    return _unwrapHtmlElement;
  },
  upsertInlineFormattingContext: function upsertInlineFormattingContext() {
    return _upsertInlineFormattingContext;
  },
  useEditableProps: function useEditableProps() {
    return _useEditableProps;
  },
  useEditorMounted: function useEditorMounted() {
    return _useEditorMounted;
  },
  useEditorReadOnly: function useEditorReadOnly() {
    return _useEditorReadOnly;
  },
  useEditorRef: function useEditorRef() {
    return _useEditorRef;
  },
  useEditorSelection: function useEditorSelection() {
    return _useEditorSelection;
  },
  useEditorSelector: function useEditorSelector() {
    return _useEditorSelector;
  },
  useEditorState: function useEditorState() {
    return _useEditorState;
  },
  useEditorVersion: function useEditorVersion() {
    return _useEditorVersion;
  },
  useElement: function useElement() {
    return _useElement;
  },
  useElementStore: function useElementStore() {
    return _useElementStore;
  },
  useEventEditorSelectors: function useEventEditorSelectors() {
    return _useEventEditorSelectors;
  },
  useEventPlateId: function useEventPlateId() {
    return _useEventPlateId;
  },
  useFocusEditorEvents: function useFocusEditorEvents() {
    return _useFocusEditorEvents;
  },
  useHotkeys: function useHotkeys() {
    return import_react_hotkeys_hook.useHotkeys;
  },
  useIncrementVersion: function useIncrementVersion() {
    return _useIncrementVersion;
  },
  usePlateActions: function usePlateActions() {
    return _usePlateActions;
  },
  usePlateControllerActions: function usePlateControllerActions() {
    return _usePlateControllerActions;
  },
  usePlateControllerEditorStore: function usePlateControllerEditorStore() {
    return _usePlateControllerEditorStore;
  },
  usePlateControllerExists: function usePlateControllerExists() {
    return _usePlateControllerExists;
  },
  usePlateControllerSelectors: function usePlateControllerSelectors() {
    return _usePlateControllerSelectors;
  },
  usePlateControllerStates: function usePlateControllerStates() {
    return _usePlateControllerStates;
  },
  usePlateControllerStore: function usePlateControllerStore() {
    return _usePlateControllerStore;
  },
  usePlateEditorStore: function usePlateEditorStore() {
    return _usePlateEditorStore;
  },
  usePlateEffects: function usePlateEffects() {
    return _usePlateEffects;
  },
  usePlateId: function usePlateId() {
    return _usePlateId;
  },
  usePlateSelectors: function usePlateSelectors() {
    return _usePlateSelectors;
  },
  usePlateStates: function usePlateStates() {
    return _usePlateStates;
  },
  usePlateStore: function usePlateStore() {
    return _usePlateStore;
  },
  useRedecorate: function useRedecorate() {
    return _useRedecorate;
  },
  useReplaceEditor: function useReplaceEditor() {
    return _useReplaceEditor;
  },
  useSelectionVersion: function useSelectionVersion() {
    return _useSelectionVersion;
  },
  useSlateProps: function useSlateProps() {
    return _useSlateProps;
  },
  withEditorProtocol: function withEditorProtocol() {
    return _withEditorProtocol;
  },
  withHOC: function withHOC() {
    return _withHOC;
  },
  withInlineVoid: function withInlineVoid() {
    return _withInlineVoid;
  },
  withInsertData: function withInsertData() {
    return _withInsertData;
  },
  withLength: function withLength() {
    return _withLength;
  },
  withPlate: function withPlate() {
    return _withPlate;
  },
  withTHistory: function withTHistory() {
    return _withTHistory;
  },
  withTReact: function withTReact() {
    return _withTReact;
  }
});
module.exports = __toCommonJS(src_exports);

// src/client/components/EditorMethodsEffect.ts
var import_react14 = __toESM(require("react"));

// src/shared/types/PlateStore.ts
var _EXPOSED_STORE_KEYS = ["readOnly", "plugins", "onChange", "decorate", "renderElement", "renderLeaf"];

// src/client/libs/jotai.ts
var import_jotai = require("jotai");
var import_jotai_x = require("jotai-x");

// src/client/stores/element/useElementStore.ts
var _SCOPE_ELEMENT = "element";
var initialState = {
  element: null
};
var _ref = (0, import_jotai_x.createAtomStore)(initialState, {
    name: "element"
  }),
  _ElementProvider = _ref.ElementProvider,
  _useElementStore = _ref.useElementStore; // src/client/stores/element/useElement.ts
var _useElement = function _useElement() {
  var pluginKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _SCOPE_ELEMENT;
  var value = _useElementStore(pluginKey).get.element();
  if (!value) {
    console.warn("The `useElement(pluginKey)` hook must be used inside the node component's context");
    return {};
  }
  return value;
};

// src/shared/libs/nanoid.ts
var import_nanoid = require("nanoid");

// src/shared/libs/zustand.ts
var import_zustand_x = require("zustand-x");

// src/shared/plugins/event-editor/eventEditorStore.ts
var _eventEditorStore = (0, import_zustand_x.createZustandStore)("event-editor")({
  blur: null,
  focus: null,
  last: null
});
var _eventEditorActions = _eventEditorStore.set;
var _eventEditorSelectors = _eventEditorStore.get;
var _useEventEditorSelectors = _eventEditorStore.use;

// src/client/stores/plate/createPlateStore.ts
var import_react9 = __toESM(require("react"));
var import_jotai4 = require("jotai");

// src/client/libs/react-hotkeys-hook.ts
var import_react_hotkeys_hook = require("react-hotkeys-hook");

// src/client/utils/createPlateEditor.ts
var import_slate9 = require("@udecode/slate");

// src/shared/utils/createPlugins.tsx
var import_cloneDeep = __toESM(require("lodash/cloneDeep.js"));

// src/shared/utils/overridePluginsByKey.ts
var import_defaultsDeep = __toESM(require("lodash/defaultsDeep.js"));
var _overridePluginsByKey2 = function _overridePluginsByKey(plugin) {
  var overrideByKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var nested = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _b;
  if (overrideByKey[plugin.key]) {
    var _a = overrideByKey[plugin.key],
      pluginOverridesPlugins = _a.plugins,
      pluginOverridesThen = _a.then,
      pluginOverrides = __objRest(_a, ["plugins", "then"]);
    plugin = (0, import_defaultsDeep.default)(pluginOverrides, plugin);
    if (!nested) {
      pluginOverridesPlugins == null ? void 0 : pluginOverridesPlugins.forEach(function (pOverrides) {
        if (!plugin.plugins) plugin.plugins = [];
        var found = plugin.plugins.find(function (p) {
          return p.key === pOverrides.key;
        });
        if (!found) plugin.plugins.push(pOverrides);
      });
    }
  }
  if (plugin.plugins) {
    plugin.plugins = plugin.plugins.map(function (p) {
      return _overridePluginsByKey2(p, overrideByKey, true);
    });
  }
  var _plugin2 = plugin,
    then = _plugin2.then;
  if (then) {
    if (plugin._thenReplaced === void 0) {
      plugin._thenReplaced = 0;
    }
    if (plugin._thenReplaced < 3) {
      plugin.then = function (editor, p) {
        var pluginThen = __spreadValues({
          key: plugin.key
        }, then(editor, p));
        return (0, import_defaultsDeep.default)(_overridePluginsByKey2(pluginThen, overrideByKey), pluginThen);
      };
      plugin._thenReplaced++;
    }
  } else if ((_b = overrideByKey[plugin.key]) == null ? void 0 : _b.then) {
    plugin.then = overrideByKey[plugin.key].then;
  }
  return plugin;
};

// src/shared/utils/createPlugins.tsx
var _createPlugins = function _createPlugins(plugins) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    components = _ref2.components,
    overrideByKey = _ref2.overrideByKey;
  var allOverrideByKey = {};
  if (overrideByKey) {
    allOverrideByKey = (0, import_cloneDeep.default)(overrideByKey);
  }
  if (components) {
    Object.keys(components).forEach(function (key) {
      if (!allOverrideByKey[key]) allOverrideByKey[key] = {};
      allOverrideByKey[key].component = components[key];
    });
  }
  if (Object.keys(allOverrideByKey).length > 0) {
    return plugins.map(function (plugin) {
      return _overridePluginsByKey2(plugin, allOverrideByKey);
    });
  }
  return plugins;
};

// src/shared/transforms/resetEditorChildren.ts
var import_slate_utils = require("@udecode/slate-utils");
var _resetEditorChildren = function _resetEditorChildren(editor, options) {
  (0, import_slate_utils.replaceNodeChildren)(editor, __spreadValues({
    at: [],
    nodes: editor.childrenFactory()
  }, options));
};

// src/shared/transforms/resetEditor.ts
var _resetEditor = function _resetEditor(editor) {
  _resetEditorChildren(editor);
  editor.history.undos = [];
  editor.history.redos = [];
  editor.operations = [];
};

// src/shared/transforms/toggleNodeType.ts
var import_slate = require("@udecode/slate");

// src/shared/constants/ELEMENT_DEFAULT.ts
var _ELEMENT_DEFAULT = "p";

// src/shared/utils/getPluginsByKey.ts
var _getPluginsByKey = function _getPluginsByKey(editor) {
  var _a;
  return (_a = editor == null ? void 0 : editor.pluginsByKey) != null ? _a : {};
};

// src/shared/utils/getPlugin.ts
var _getPlugin = function _getPlugin(editor, key) {
  var _a;
  return (_a = _getPluginsByKey(editor)[key]) != null ? _a : {
    key: key
  };
};

// src/shared/utils/getPluginType.ts
var _getPluginType = function _getPluginType(editor, key) {
  var _a, _b;
  return (_b = (_a = _getPlugin(editor, key).type) != null ? _a : key) != null ? _b : "";
};

// src/shared/transforms/toggleNodeType.ts
var _toggleNodeType = function _toggleNodeType(editor, options, editorNodesOptions) {
  var _a;
  var activeType = options.activeType,
    _options$inactiveType = options.inactiveType,
    inactiveType = _options$inactiveType === void 0 ? _getPluginType(editor, _ELEMENT_DEFAULT) : _options$inactiveType;
  var at = (_a = editorNodesOptions == null ? void 0 : editorNodesOptions.at) != null ? _a : editor.selection;
  if (!activeType || !at) return;
  var isActive = (0, import_slate.someNode)(editor, __spreadProps(__spreadValues({}, editorNodesOptions), {
    match: {
      type: activeType
    }
  }));
  if (isActive && activeType === inactiveType) return;
  (0, import_slate.setElements)(editor, {
    type: isActive ? inactiveType : activeType
  }, {
    at: at
  });
};

// src/client/utils/setPlatePlugins.ts
var import_utils6 = require("@udecode/utils");

// src/shared/plugins/createDeserializeAstPlugin.ts
var import_castArray = __toESM(require("lodash/castArray.js"));

// src/shared/utils/createPluginFactory.ts
var _createPluginFactory = function _createPluginFactory(defaultPlugin) {
  return function (override) {
    var overrideByKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    overrideByKey[defaultPlugin.key] = override;
    return _overridePluginsByKey2(__spreadValues({}, defaultPlugin), overrideByKey);
  };
};

// src/shared/plugins/createDeserializeAstPlugin.ts
var _KEY_DESERIALIZE_AST = "deserializeAst";
var _createDeserializeAstPlugin = _createPluginFactory({
  editor: {
    insertData: {
      format: "application/x-slate-fragment",
      getFragment: function getFragment(_ref3) {
        var data = _ref3.data;
        var decoded = decodeURIComponent(window.atob(data));
        var parsed;
        try {
          parsed = JSON.parse(decoded);
        } catch (error) {}
        return (0, import_castArray.default)(parsed);
      }
    }
  },
  key: _KEY_DESERIALIZE_AST
});

// src/shared/plugins/createEditorProtocolPlugin.ts
var import_slate2 = require("@udecode/slate");
var getBlockAbove = function getBlockAbove(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, import_slate2.getAboveNode)(editor, __spreadProps(__spreadValues({}, options), {
    block: true
  }));
};
var isSelectionAtBlockStart = function isSelectionAtBlockStart(editor, options) {
  var _a;
  var selection = editor.selection;
  if (!selection) return false;
  var path = (_a = getBlockAbove(editor, options)) == null ? void 0 : _a[1];
  if (!path) return false;
  return (0, import_slate2.isStartPoint)(editor, selection.focus, path) || (0, import_slate2.isExpanded)(editor.selection) && (0, import_slate2.isStartPoint)(editor, selection.anchor, path);
};
var removeSelectionMark = function removeSelectionMark(editor) {
  var marks = (0, import_slate2.getMarks)(editor);
  if (!marks) return;
  Object.keys(marks).forEach(function (key) {
    (0, import_slate2.removeEditorMark)(editor, key);
  });
};
var _KEY_EDITOR_PROTOCOL = "editorProtocol";
var _withEditorProtocol = function _withEditorProtocol(editor) {
  var deleteBackward = editor.deleteBackward,
    deleteForward = editor.deleteForward,
    deleteFragment = editor.deleteFragment;
  var resetMarks = function resetMarks() {
    if (isSelectionAtBlockStart(editor)) {
      removeSelectionMark(editor);
    }
  };
  editor.deleteBackward = function (unit) {
    deleteBackward(unit);
    resetMarks();
  };
  editor.deleteForward = function (unit) {
    deleteForward(unit);
    resetMarks();
  };
  editor.deleteFragment = function (direction) {
    deleteFragment(direction);
    resetMarks();
  };
  return editor;
};
var _createEditorProtocolPlugin = _createPluginFactory({
  key: _KEY_EDITOR_PROTOCOL,
  withOverrides: _withEditorProtocol
});

// src/shared/plugins/createHistoryPlugin.ts
var import_slate_history = require("slate-history");
var _KEY_HISTORY = "history";
var _withTHistory = function _withTHistory(editor) {
  return (0, import_slate_history.withHistory)(editor);
};
var _createHistoryPlugin = _createPluginFactory({
  key: _KEY_HISTORY,
  withOverrides: _withTHistory
});

// src/shared/plugins/createInlineVoidPlugin.ts
var _KEY_INLINE_VOID = "inline-void";
var _withInlineVoid = function _withInlineVoid(editor) {
  var isInline = editor.isInline,
    isVoid = editor.isVoid,
    markableVoid = editor.markableVoid;
  var voidTypes = [];
  var inlineTypes = [];
  var markableVoidTypes = [];
  editor.plugins.forEach(function (plugin) {
    if (plugin.isInline) {
      inlineTypes.push(plugin.type);
    }
    if (plugin.isVoid) {
      voidTypes.push(plugin.type);
    }
    if (plugin.isMarkableVoid) {
      markableVoidTypes.push(plugin.type);
    }
  });
  editor.isInline = function (element) {
    return inlineTypes.includes(element.type) ? true : isInline(element);
  };
  editor.isVoid = function (element) {
    return voidTypes.includes(element.type) ? true : isVoid(element);
  };
  editor.markableVoid = function (element) {
    return markableVoidTypes.includes(element.type) ? true : markableVoid(element);
  };
  return editor;
};
var _createInlineVoidPlugin = _createPluginFactory({
  key: _KEY_INLINE_VOID,
  withOverrides: _withInlineVoid
});

// src/shared/utils/getInjectedPlugins.ts
var _getInjectedPlugins = function _getInjectedPlugins(editor, plugin) {
  var injectedPlugins = [];
  _toConsumableArray(editor.plugins).reverse().forEach(function (p) {
    var _a;
    var injectedPlugin = (_a = p.inject.pluginsByKey) == null ? void 0 : _a[plugin.key];
    if (injectedPlugin) injectedPlugins.push(injectedPlugin);
  });
  return [plugin].concat(injectedPlugins);
};

// src/shared/utils/pipeInsertDataQuery.ts
var _pipeInsertDataQuery = function _pipeInsertDataQuery(plugins, _ref4) {
  var data = _ref4.data,
    dataTransfer = _ref4.dataTransfer;
  return plugins.every(function (p) {
    var _a, _b;
    var query = (_b = (_a = p.editor) == null ? void 0 : _a.insertData) == null ? void 0 : _b.query;
    return !query || query({
      data: data,
      dataTransfer: dataTransfer
    });
  });
};

// src/shared/utils/pipeInsertFragment.ts
var import_slate3 = require("@udecode/slate");
var _pipeInsertFragment = function _pipeInsertFragment(editor, injectedPlugins, _a) {
  var _b = _a,
    fragment = _b.fragment,
    options = __objRest(_b, ["fragment"]);
  (0, import_slate3.withoutNormalizing)(editor, function () {
    injectedPlugins.some(function (p) {
      var _a2, _b2, _c;
      return ((_c = (_b2 = (_a2 = p.editor) == null ? void 0 : _a2.insertData) == null ? void 0 : _b2.preInsert) == null ? void 0 : _c.call(_b2, fragment, options)) === true;
    });
    editor.insertFragment(fragment);
  });
};

// src/shared/utils/pipeTransformData.ts
var _pipeTransformData = function _pipeTransformData(plugins, _ref5) {
  var data = _ref5.data,
    dataTransfer = _ref5.dataTransfer;
  plugins.forEach(function (p) {
    var _a, _b;
    var transformData = (_b = (_a = p.editor) == null ? void 0 : _a.insertData) == null ? void 0 : _b.transformData;
    if (!transformData) return;
    data = transformData(data, {
      dataTransfer: dataTransfer
    });
  });
  return data;
};

// src/shared/utils/pipeTransformFragment.ts
var _pipeTransformFragment = function _pipeTransformFragment(plugins, _a) {
  var _b = _a,
    fragment = _b.fragment,
    options = __objRest(_b, ["fragment"]);
  plugins.forEach(function (p) {
    var _a2, _b2;
    var transformFragment = (_b2 = (_a2 = p.editor) == null ? void 0 : _a2.insertData) == null ? void 0 : _b2.transformFragment;
    if (!transformFragment) return;
    fragment = transformFragment(fragment, options);
  });
  return fragment;
};

// src/shared/plugins/createInsertDataPlugin.ts
var _withInsertData = function _withInsertData(editor) {
  var insertData = editor.insertData;
  editor.insertData = function (dataTransfer) {
    var inserted = _toConsumableArray(editor.plugins).reverse().some(function (plugin) {
      var insertDataOptions = plugin.editor.insertData;
      if (!insertDataOptions) return false;
      var injectedPlugins = _getInjectedPlugins(editor, plugin);
      var format = insertDataOptions.format,
        getFragment = insertDataOptions.getFragment;
      if (!format) return false;
      var data = dataTransfer.getData(format);
      if (!data) return;
      if (!_pipeInsertDataQuery(injectedPlugins, {
        data: data,
        dataTransfer: dataTransfer
      })) {
        return false;
      }
      data = _pipeTransformData(injectedPlugins, {
        data: data,
        dataTransfer: dataTransfer
      });
      var fragment = getFragment == null ? void 0 : getFragment({
        data: data,
        dataTransfer: dataTransfer
      });
      if (!(fragment == null ? void 0 : fragment.length)) return false;
      fragment = _pipeTransformFragment(injectedPlugins, {
        data: data,
        dataTransfer: dataTransfer,
        fragment: fragment
      });
      if (fragment.length === 0) return false;
      _pipeInsertFragment(editor, injectedPlugins, {
        data: data,
        dataTransfer: dataTransfer,
        fragment: fragment
      });
      return true;
    });
    if (inserted) return;
    insertData(dataTransfer);
  };
  return editor;
};
var _KEY_INSERT_DATA = "insertData";
var _createInsertDataPlugin = _createPluginFactory({
  key: _KEY_INSERT_DATA,
  withOverrides: _withInsertData
});

// src/shared/plugins/createLengthPlugin.ts
var import_slate4 = require("@udecode/slate");
var _KEY_LENGTH = "length";
var _withLength = function _withLength(editor, _ref6) {
  var options = _ref6.options;
  var apply = editor.apply;
  editor.apply = function (operation) {
    (0, import_slate4.withoutNormalizing)(editor, function () {
      apply(operation);
      if (options.maxLength) {
        var length = (0, import_slate4.getEditorString)(editor, []).length;
        if (length > options.maxLength) {
          var overflowLength = length - options.maxLength;
          editor.delete({
            distance: overflowLength,
            reverse: true,
            unit: "character"
          });
        }
      }
    });
  };
  return editor;
};
var _createLengthPlugin = _createPluginFactory({
  key: _KEY_LENGTH,
  withOverrides: _withLength
});

// src/shared/utils/applyDeepToNodes.ts
var import_slate5 = require("@udecode/slate");
var _applyDeepToNodes2 = function _applyDeepToNodes(_ref7) {
  var apply = _ref7.apply,
    node = _ref7.node,
    _ref7$path = _ref7.path,
    path = _ref7$path === void 0 ? [] : _ref7$path,
    query = _ref7.query,
    source = _ref7.source;
  var entry = [node, path];
  if ((0, import_slate5.queryNode)(entry, query)) {
    if (source instanceof Function) {
      apply(node, source());
    } else {
      apply(node, source);
    }
  }
  if (!(0, import_slate5.isAncestor)(node)) return;
  node.children.forEach(function (child, index) {
    _applyDeepToNodes2({
      apply: apply,
      node: child,
      path: path.concat([index]),
      query: query,
      source: source
    });
  });
};

// src/shared/utils/flattenDeepPlugins.ts
var import_defaultsDeep3 = __toESM(require("lodash/defaultsDeep.js"));

// src/shared/utils/mergeDeepPlugins.ts
var import_defaultsDeep2 = __toESM(require("lodash/defaultsDeep.js"));
var import_keyBy = __toESM(require("lodash/keyBy.js"));
var import_merge = __toESM(require("lodash/merge.js"));
var import_values = __toESM(require("lodash/values.js"));
var _mergeDeepPlugins2 = function _mergeDeepPlugins(editor, _plugin) {
  var plugin = __spreadValues({}, _plugin);
  var then = plugin.then;
  if (then) {
    delete plugin.then;
    var pluginPlugins = plugin.plugins;
    var pluginThen = _mergeDeepPlugins2(editor, (0, import_defaultsDeep2.default)(then(editor, plugin), plugin));
    if (pluginPlugins && pluginThen.plugins) {
      var merged = (0, import_merge.default)((0, import_keyBy.default)(pluginPlugins, "key"), (0, import_keyBy.default)(pluginThen.plugins, "key"));
      pluginThen.plugins = (0, import_values.default)(merged);
    }
    return pluginThen;
  }
  return plugin;
};

// src/shared/utils/setDefaultPlugin.ts
var _setDefaultPlugin = function _setDefaultPlugin(plugin) {
  if (plugin.type === void 0) plugin.type = plugin.key;
  if (!plugin.options) plugin.options = {};
  if (!plugin.inject) plugin.inject = {};
  if (!plugin.editor) plugin.editor = {};
  return plugin;
};

// src/shared/utils/flattenDeepPlugins.ts
var _flattenDeepPlugins2 = function _flattenDeepPlugins(editor, plugins) {
  if (!plugins) return;
  plugins.forEach(function (plugin) {
    var p = _setDefaultPlugin(plugin);
    p = _mergeDeepPlugins2(editor, p);
    if (p.enabled === false) return;
    if (editor.pluginsByKey[p.key]) {
      var index = editor.plugins.indexOf(editor.pluginsByKey[p.key]);
      var mergedPlugin = (0, import_defaultsDeep3.default)(p, editor.pluginsByKey[p.key]);
      if (index >= 0) {
        editor.plugins[index] = mergedPlugin;
      }
      editor.pluginsByKey[p.key] = mergedPlugin;
    } else {
      editor.plugins.push(p);
      editor.pluginsByKey[p.key] = p;
    }
    _flattenDeepPlugins2(editor, p.plugins);
  });
};

// src/shared/utils/getKeysByTypes.ts
var import_castArray2 = __toESM(require("lodash/castArray.js"));
var _getKeysByTypes = function _getKeysByTypes(editor, type) {
  var types = (0, import_castArray2.default)(type);
  var found = Object.values(editor.pluginsByKey).filter(function (plugin) {
    return types.includes(plugin.type);
  });
  return found.map(function (p) {
    return p.key;
  });
};

// src/shared/utils/getKeyByType.ts
var _getKeyByType = function _getKeyByType(editor, type) {
  return _getKeysByTypes(editor, type)[0];
};

// src/shared/utils/getPluginInjectProps.ts
var _getPluginInjectProps = function _getPluginInjectProps(editor, key) {
  var _a, _b;
  return (_b = (_a = _getPlugin(editor, key).inject) == null ? void 0 : _a.props) != null ? _b : {};
};

// src/shared/utils/getPluginOptions.ts
var _getPluginOptions = function _getPluginOptions(editor, key) {
  var _a;
  return (_a = _getPlugin(editor, key).options) != null ? _a : {};
};

// src/shared/utils/getPluginTypes.ts
var _getPluginTypes = function _getPluginTypes(editor, keys) {
  return keys.map(function (key) {
    return _getPluginType(editor, key);
  });
};

// src/shared/utils/getPlugins.ts
var _getPlugins = function _getPlugins(editor) {
  var _a;
  return (_a = editor == null ? void 0 : editor.plugins) != null ? _a : [];
};

// src/shared/utils/getRenderNodeProps.ts
var import_clsx = require("clsx");
var import_pick = __toESM(require("lodash/pick.js"));

// src/shared/utils/misc/getSlateClass.ts
var _getSlateClass = function _getSlateClass(type) {
  return "slate-".concat(type);
};

// src/shared/utils/getRenderNodeProps.ts
var _getRenderNodeProps = function _getRenderNodeProps(_ref8) {
  var attributes = _ref8.attributes,
    dangerouslyAllowAttributes = _ref8.dangerouslyAllowAttributes,
    nodeProps = _ref8.nodeProps,
    props = _ref8.props,
    type = _ref8.type;
  var _a;
  var newProps = {};
  if (props) {
    newProps = (_a = typeof props === "function" ? props(nodeProps) : props) != null ? _a : {};
  }
  if (!newProps.nodeProps && attributes) {
    newProps.nodeProps = (0, import_pick.default)(attributes, dangerouslyAllowAttributes != null ? dangerouslyAllowAttributes : []);
  }
  nodeProps = __spreadValues(__spreadValues({}, nodeProps), newProps);
  if (nodeProps.nodeProps) {
    Object.keys(nodeProps.nodeProps).forEach(function (key) {
      var _a2, _b;
      if (((_a2 = nodeProps.nodeProps) == null ? void 0 : _a2[key]) === void 0) {
        (_b = nodeProps.nodeProps) == null ? true : delete _b[key];
      }
    });
  }
  var _nodeProps = nodeProps,
    className = _nodeProps.className;
  return __spreadProps(__spreadValues({}, nodeProps), {
    className: (0, import_clsx.clsx)(_getSlateClass(type), className)
  });
};

// src/shared/utils/mapInjectPropsToPlugin.ts
var _mapInjectPropsToPlugin = function _mapInjectPropsToPlugin(editor, plugin, injectedPlugin) {
  var _a;
  var validTypes = (_a = plugin.inject.props) == null ? void 0 : _a.validTypes;
  if (!validTypes) return;
  var keys = _getKeysByTypes(editor, validTypes);
  var injected = {};
  keys.forEach(function (key) {
    injected[key] = injectedPlugin;
  });
  return {
    inject: {
      pluginsByKey: injected
    }
  };
};

// src/shared/utils/mergeDeepToNodes.ts
var import_merge2 = __toESM(require("lodash/merge.js"));
var _mergeDeepToNodes = function _mergeDeepToNodes(options) {
  _applyDeepToNodes2(__spreadProps(__spreadValues({}, options), {
    apply: import_merge2.default
  }));
};

// src/shared/utils/mockPlugin.ts
var _mockPlugin = function _mockPlugin(plugin) {
  return __spreadValues({
    editor: {},
    inject: {},
    key: "",
    options: {},
    type: ""
  }, plugin);
};

// src/shared/utils/normalizeDescendantsToDocumentFragment.ts
var import_slate6 = require("@udecode/slate");
var isInlineNode = function isInlineNode(editor) {
  return function (node) {
    return (0, import_slate6.isText)(node) || (0, import_slate6.isElement)(node) && editor.isInline(node);
  };
};
var makeBlockLazy = function makeBlockLazy(type) {
  return function () {
    return {
      children: [],
      type: type
    };
  };
};
var hasDifferentChildNodes = function hasDifferentChildNodes(descendants, isInline) {
  return descendants.some(function (descendant, index, arr) {
    var prevDescendant = arr[index - 1];
    if (index !== 0) {
      return isInline(descendant) !== isInline(prevDescendant);
    }
    return false;
  });
};
var normalizeDifferentNodeTypes = function normalizeDifferentNodeTypes(descendants, isInline, makeDefaultBlock) {
  var hasDifferentNodes = hasDifferentChildNodes(descendants, isInline);
  var _descendants$reduce = descendants.reduce(function (memo, node) {
      if (hasDifferentNodes && isInline(node)) {
        var block = memo.precedingBlock;
        if (!block) {
          block = makeDefaultBlock();
          memo.precedingBlock = block;
          memo.fragment.push(block);
        }
        block.children.push(node);
      } else {
        memo.fragment.push(node);
        memo.precedingBlock = null;
      }
      return memo;
    }, {
      fragment: [],
      precedingBlock: null
    }),
    fragment = _descendants$reduce.fragment;
  return fragment;
};
var normalizeEmptyChildren = function normalizeEmptyChildren(descendants) {
  if (descendants.length === 0) {
    return [{
      text: ""
    }];
  }
  return descendants;
};
var _normalize = function normalize(descendants, isInline, makeDefaultBlock) {
  descendants = normalizeEmptyChildren(descendants);
  descendants = normalizeDifferentNodeTypes(descendants, isInline, makeDefaultBlock);
  descendants = descendants.map(function (node) {
    if ((0, import_slate6.isElement)(node)) {
      return __spreadProps(__spreadValues({}, node), {
        children: _normalize(node.children, isInline, makeDefaultBlock)
      });
    }
    return node;
  });
  return descendants;
};
var _normalizeDescendantsToDocumentFragment = function _normalizeDescendantsToDocumentFragment(editor, _ref9) {
  var descendants = _ref9.descendants;
  var isInline = isInlineNode(editor);
  var defaultType = _getPluginType(editor, _ELEMENT_DEFAULT);
  var makeDefaultBlock = makeBlockLazy(defaultType);
  return _normalize(descendants, isInline, makeDefaultBlock);
};

// src/shared/utils/normalizeInitialValue.ts
var import_cloneDeep2 = __toESM(require("lodash/cloneDeep.js"));
var import_isEqual = __toESM(require("lodash/isEqual.js"));
var _normalizeInitialValue = function _normalizeInitialValue(editor, value) {
  var normalizedValue = (0, import_cloneDeep2.default)(value);
  editor.plugins.forEach(function (p) {
    var _a;
    var _normalizedValue = (_a = p.normalizeInitialValue) == null ? void 0 : _a.call(p, normalizedValue);
    if (_normalizedValue) {
      normalizedValue = _normalizedValue;
    }
  });
  if (!(0, import_isEqual.default)(value, normalizedValue)) {
    return normalizedValue;
  }
};

// src/shared/utils/pipeDecorate.ts
var _pipeDecorate = function _pipeDecorate(editor, decorateProp) {
  var decorates = editor.plugins.flatMap(function (plugin) {
    var _a, _b;
    return (_b = (_a = plugin.decorate) == null ? void 0 : _a.call(plugin, editor, plugin)) != null ? _b : [];
  });
  if (decorateProp) {
    decorates.push(decorateProp);
  }
  if (decorates.length === 0) return;
  return function (entry) {
    var ranges = [];
    var addRanges = function addRanges(newRanges) {
      if (newRanges == null ? void 0 : newRanges.length) ranges = [].concat(_toConsumableArray(ranges), _toConsumableArray(newRanges));
    };
    decorates.forEach(function (decorate) {
      addRanges(decorate(entry));
    });
    return ranges;
  };
};

// src/shared/utils/pipeHandler.ts
var _convertDomEventToSyntheticEvent = function _convertDomEventToSyntheticEvent(domEvent) {
  var propagationStopped = false;
  return __spreadProps(__spreadValues({}, domEvent), {
    bubbles: domEvent.bubbles,
    cancelable: domEvent.cancelable,
    currentTarget: domEvent.currentTarget,
    defaultPrevented: domEvent.defaultPrevented,
    eventPhase: domEvent.eventPhase,
    isDefaultPrevented: function isDefaultPrevented() {
      return domEvent.defaultPrevented;
    },
    isPropagationStopped: function isPropagationStopped() {
      return propagationStopped;
    },
    isTrusted: domEvent.isTrusted,
    nativeEvent: domEvent,
    persist: function persist() {
      throw new Error("persist is not implemented for synthetic events created using convertDomEventToSyntheticEvent");
    },
    preventDefault: function preventDefault() {
      return domEvent.preventDefault();
    },
    stopPropagation: function stopPropagation() {
      propagationStopped = true;
      domEvent.stopPropagation();
    },
    target: domEvent.target,
    timeStamp: domEvent.timeStamp,
    type: domEvent.type
  });
};
var _isEventHandled = function _isEventHandled(event, handler) {
  if (!handler) {
    return false;
  }
  var shouldTreatEventAsHandled = handler(event);
  if (shouldTreatEventAsHandled != null) {
    return shouldTreatEventAsHandled;
  }
  return event.isPropagationStopped();
};
var _pipeHandler = function _pipeHandler(editor, _ref10) {
  var editableProps = _ref10.editableProps,
    handlerKey = _ref10.handlerKey;
  var pluginsHandlers = [];
  pluginsHandlers = editor.plugins.flatMap(function (plugin) {
    var _a, _b, _c;
    return (_c = (_b = (_a = plugin.handlers) == null ? void 0 : _a[handlerKey]) == null ? void 0 : _b.call(_a, editor, plugin)) != null ? _c : [];
  });
  var propsHandler = editableProps == null ? void 0 : editableProps[handlerKey];
  if (pluginsHandlers.length === 0 && !propsHandler) return;
  return function (event) {
    var isDomEvent = event instanceof Event;
    var handledEvent = isDomEvent ? _convertDomEventToSyntheticEvent(event) : event;
    var eventIsHandled = pluginsHandlers.some(function (handler) {
      return _isEventHandled(handledEvent, handler);
    });
    if (eventIsHandled) return true;
    return _isEventHandled(handledEvent, propsHandler);
  };
};

// src/shared/utils/pluginInjectProps.ts
var import_slate7 = require("@udecode/slate");
var import_utils = require("@udecode/utils");
var import_clsx2 = require("clsx");
var _pluginInjectProps = function _pluginInjectProps(editor, _ref11, nodeProps) {
  var props = _ref11.inject.props,
    key = _ref11.key;
  var _a, _b, _c, _d;
  var className = nodeProps.className,
    element = nodeProps.element,
    style = nodeProps.style,
    text = nodeProps.text;
  var node = element != null ? element : text;
  if (!node) return;
  if (!props) return;
  var classNames = props.classNames,
    defaultNodeValue = props.defaultNodeValue,
    _props$nodeKey = props.nodeKey,
    nodeKey = _props$nodeKey === void 0 ? key : _props$nodeKey,
    query = props.query,
    _props$styleKey = props.styleKey,
    styleKey = _props$styleKey === void 0 ? nodeKey : _props$styleKey,
    transformClassName = props.transformClassName,
    transformNodeValue = props.transformNodeValue,
    transformProps = props.transformProps,
    transformStyle = props.transformStyle,
    validNodeValues = props.validNodeValues,
    validTypes = props.validTypes;
  var queryResult = query == null ? void 0 : query(props, nodeProps);
  if (!queryResult && validTypes && (0, import_slate7.isElement)(node) && node.type && !validTypes.includes(node.type)) {
    return;
  }
  var nodeValue = node[nodeKey];
  if (!queryResult && (!(0, import_utils.isDefined)(nodeValue) || validNodeValues && !validNodeValues.includes(nodeValue) || nodeValue === defaultNodeValue)) {
    return;
  }
  var transformOptions = __spreadProps(__spreadValues({}, nodeProps), {
    nodeValue: nodeValue
  });
  var value = (_a = transformNodeValue == null ? void 0 : transformNodeValue(transformOptions)) != null ? _a : nodeValue;
  transformOptions.value = value;
  var res = {};
  if (element) {
    res.className = (0, import_clsx2.clsx)(className, "slate-".concat(nodeKey, "-").concat(nodeValue));
  }
  if ((classNames == null ? void 0 : classNames[nodeValue]) || transformClassName) {
    res.className = (_b = transformClassName == null ? void 0 : transformClassName(transformOptions)) != null ? _b : (0, import_clsx2.clsx)(className, classNames == null ? void 0 : classNames[value]);
  }
  if (styleKey) {
    res.style = (_c = transformStyle == null ? void 0 : transformStyle(transformOptions)) != null ? _c : __spreadProps(__spreadValues({}, style), _defineProperty({}, styleKey, value));
  }
  if (transformProps) {
    res = (_d = transformProps(transformOptions, res)) != null ? _d : res;
  }
  return res;
};

// src/shared/utils/pipeInjectProps.tsx
var _pipeInjectProps = function _pipeInjectProps(editor, nodeProps) {
  editor.plugins.forEach(function (plugin) {
    if (plugin.inject.props) {
      var props = _pluginInjectProps(editor, plugin, nodeProps);
      if (props) {
        nodeProps = __spreadValues(__spreadValues({}, nodeProps), props);
      }
    }
  });
  return __spreadProps(__spreadValues({}, nodeProps), {
    editor: editor
  });
};

// src/shared/utils/pipeOnChange.ts
var _pipeOnChange = function _pipeOnChange(editor) {
  var onChanges = editor.plugins.flatMap(function (plugin) {
    var _a, _b, _c;
    return (_c = (_b = (_a = plugin.handlers) == null ? void 0 : _a.onChange) == null ? void 0 : _b.call(_a, editor, plugin)) != null ? _c : [];
  });
  return function (nodes) {
    return onChanges.some(function (handler) {
      if (!handler) {
        return false;
      }
      var shouldTreatEventAsHandled = handler(nodes);
      if (shouldTreatEventAsHandled != null) {
        return shouldTreatEventAsHandled;
      }
      return false;
    });
  };
};

// src/shared/utils/shared-hotkeys.ts
var import_utils2 = require("@udecode/utils");
var import_is_hotkey = require("is-hotkey");
var import_is_hotkey2 = require("is-hotkey");
var HOTKEYS = {
  bold: "mod+b",
  compose: ["down", "left", "right", "up", "backspace", "enter"],
  deleteBackward: "shift?+backspace",
  deleteForward: "shift?+delete",
  extendBackward: "shift+left",
  extendForward: "shift+right",
  insertSoftBreak: "shift+enter",
  italic: "mod+i",
  moveBackward: "left",
  moveForward: "right",
  moveWordBackward: "ctrl+left",
  moveWordForward: "ctrl+right",
  splitBlock: "enter",
  tab: "tab",
  undo: "mod+z",
  untab: "shift+tab"
};
var APPLE_HOTKEYS = {
  deleteBackward: ["ctrl+backspace", "ctrl+h"],
  deleteForward: ["ctrl+delete", "ctrl+d"],
  deleteLineBackward: "cmd+shift?+backspace",
  deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
  deleteWordBackward: "opt+shift?+backspace",
  deleteWordForward: "opt+shift?+delete",
  extendLineBackward: "opt+shift+up",
  extendLineForward: "opt+shift+down",
  moveLineBackward: "opt+up",
  moveLineForward: "opt+down",
  moveWordBackward: "opt+left",
  moveWordForward: "opt+right",
  redo: "cmd+shift+z",
  transposeCharacter: "ctrl+t"
};
var WINDOWS_HOTKEYS = {
  deleteWordBackward: "ctrl+shift?+backspace",
  deleteWordForward: "ctrl+shift?+delete",
  redo: ["ctrl+y", "ctrl+shift+z"]
};
var _createHotkey = function _createHotkey(key) {
  var generic = HOTKEYS[key];
  var apple = APPLE_HOTKEYS[key];
  var windows = WINDOWS_HOTKEYS[key];
  var isGeneric = generic && (0, import_is_hotkey.isKeyHotkey)(generic);
  var isApple = apple && (0, import_is_hotkey.isKeyHotkey)(apple);
  var isWindows = windows && (0, import_is_hotkey.isKeyHotkey)(windows);
  return function (event) {
    if (isGeneric == null ? void 0 : isGeneric(event)) return true;
    if (import_utils2.IS_APPLE && (isApple == null ? void 0 : isApple(event))) return true;
    if (!import_utils2.IS_APPLE && (isWindows == null ? void 0 : isWindows(event))) return true;
    return false;
  };
};
var _sharedHotkeys = {
  isBold: _createHotkey("bold"),
  isCompose: _createHotkey("compose"),
  isDeleteBackward: _createHotkey("deleteBackward"),
  isDeleteForward: _createHotkey("deleteForward"),
  isDeleteLineBackward: _createHotkey("deleteLineBackward"),
  isDeleteLineForward: _createHotkey("deleteLineForward"),
  isDeleteWordBackward: _createHotkey("deleteWordBackward"),
  isDeleteWordForward: _createHotkey("deleteWordForward"),
  isExtendBackward: _createHotkey("extendBackward"),
  isExtendForward: _createHotkey("extendForward"),
  isExtendLineBackward: _createHotkey("extendLineBackward"),
  isExtendLineForward: _createHotkey("extendLineForward"),
  isItalic: _createHotkey("italic"),
  isMoveBackward: _createHotkey("moveBackward"),
  isMoveForward: _createHotkey("moveForward"),
  isMoveLineBackward: _createHotkey("moveLineBackward"),
  isMoveLineForward: _createHotkey("moveLineForward"),
  isMoveWordBackward: _createHotkey("moveWordBackward"),
  isMoveWordForward: _createHotkey("moveWordForward"),
  isRedo: _createHotkey("redo"),
  isSoftBreak: _createHotkey("insertSoftBreak"),
  isSplitBlock: _createHotkey("splitBlock"),
  isTransposeCharacter: _createHotkey("transposeCharacter"),
  isUndo: _createHotkey("undo")
};

// src/shared/utils/withHOC.tsx
var import_react = __toESM(require("react"));
var _withHOC = function _withHOC(HOC, Component, hocProps, hocRef) {
  return import_react.default.forwardRef(function (props, componentRef) {
    return /* @__PURE__ */import_react.default.createElement(HOC, __spreadProps(__spreadValues({}, hocProps), {
      ref: hocRef
    }), /* @__PURE__ */import_react.default.createElement(Component, __spreadProps(__spreadValues({}, props), {
      ref: componentRef
    })));
  });
};

// src/shared/plugins/createNodeFactoryPlugin.ts
var _KEY_NODE_FACTORY = "nodeFactory";
var _createNodeFactoryPlugin = _createPluginFactory({
  key: _KEY_NODE_FACTORY,
  withOverrides: function withOverrides(editor) {
    editor.blockFactory = function (node) {
      return __spreadValues({
        children: [{
          text: ""
        }],
        type: _getPluginType(editor, _ELEMENT_DEFAULT)
      }, node);
    };
    editor.childrenFactory = function () {
      return [editor.blockFactory()];
    };
    return editor;
  }
});

// src/shared/plugins/createPrevSelectionPlugin.ts
var _KEY_PREV_SELECTION = "prevSelection";
var _createPrevSelectionPlugin = _createPluginFactory({
  handlers: {
    onKeyDown: function onKeyDown(editor) {
      return function (e) {
        e.persist();
        editor.currentKeyboardEvent = e;
      };
    }
  },
  key: _KEY_PREV_SELECTION,
  withOverrides: function withOverrides(editor) {
    var apply = editor.apply;
    editor.apply = function (operation) {
      if (operation.type === "set_selection") {
        var properties = operation.properties;
        editor.prevSelection = properties;
        apply(operation);
        editor.currentKeyboardEvent = null;
        return;
      }
      apply(operation);
    };
    return editor;
  }
});

// src/shared/plugins/event-editor/constants.ts
var _FOCUS_EDITOR_EVENT = "focus-editor-event";
var _BLUR_EDITOR_EVENT = "blur-editor-event";

// src/shared/plugins/event-editor/createEventEditorPlugin.ts
var _KEY_EVENT_EDITOR = "event-editor";
var _createEventEditorPlugin = _createPluginFactory({
  handlers: {
    onBlur: function onBlur(editor) {
      return function () {
        var focus = _eventEditorSelectors.focus();
        if (focus === editor.id) {
          _eventEditorActions.focus(null);
        }
        _eventEditorActions.blur(editor.id);
        document.dispatchEvent(new CustomEvent(_BLUR_EDITOR_EVENT, {
          detail: {
            id: editor.id
          }
        }));
      };
    },
    onFocus: function onFocus(editor) {
      return function () {
        _eventEditorActions.focus(editor.id);
        document.dispatchEvent(new CustomEvent(_FOCUS_EDITOR_EVENT, {
          detail: {
            id: editor.id
          }
        }));
      };
    }
  },
  key: _KEY_EVENT_EDITOR
});

// src/shared/plugins/event-editor/getEventPlateId.ts
var _getEventPlateId = function _getEventPlateId(id) {
  var _a;
  if (id) return id;
  var focus = _eventEditorSelectors.focus();
  if (focus) return focus;
  var blur = _eventEditorSelectors.blur();
  if (blur) return blur;
  return (_a = _eventEditorSelectors.last()) != null ? _a : "plate";
};

// src/shared/plugins/html-deserializer/constants.ts
var _CARRIAGE_RETURN = "\r";
var _LINE_FEED = "\n";
var _NO_BREAK_SPACE = "\xA0";
var _SPACE = " ";
var _TAB = "	";
var _ZERO_WIDTH_SPACE = "\u200B";

// src/shared/plugins/html-deserializer/utils/collapse-white-space/collapseString.ts
var _collapseString = function _collapseString(text) {
  var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref12$shouldCollapse = _ref12.shouldCollapseWhiteSpace,
    shouldCollapseWhiteSpace = _ref12$shouldCollapse === void 0 ? true : _ref12$shouldCollapse,
    _ref12$trimEnd = _ref12.trimEnd,
    trimEnd = _ref12$trimEnd === void 0 ? "collapse" : _ref12$trimEnd,
    _ref12$trimStart = _ref12.trimStart,
    trimStart = _ref12$trimStart === void 0 ? "collapse" : _ref12$trimStart,
    _ref12$whiteSpaceIncl = _ref12.whiteSpaceIncludesNewlines,
    whiteSpaceIncludesNewlines = _ref12$whiteSpaceIncl === void 0 ? true : _ref12$whiteSpaceIncl;
  if (trimStart === "all") {
    text = text.replace(/^\s+/, "");
  }
  if (trimEnd === "single-newline") {
    text = text.replace(/\n$/, "");
  }
  if (shouldCollapseWhiteSpace) {
    if (whiteSpaceIncludesNewlines) {
      text = text.replaceAll(/\s+/g, " ");
    } else {
      text = text.replaceAll(/[^\S\n\r]+/g, " ");
      text = text.replaceAll(/^[^\S\n\r]+/gm, "");
      text = text.replaceAll(/[^\S\n\r]+$/gm, "");
    }
  }
  return text;
};

// src/shared/plugins/html-deserializer/utils/inlineTagNames.ts
var _inlineTagNames = /* @__PURE__ */new Set(["A", "ABBR", "B", "BDI", "BDO", "BR", "CITE", "CODE", "DATA", "DFN", "EM", "I", "KBD", "MARK", "Q", "S", "SAMP", "SMALL", "SPAN", "STRONG", "SUB", "SUP", "TIME", "U", "VAR", "WBR", "IMG", "MAP", "TRACK", "VIDEO", "EMBED", "IFRAME", "OBJECT", "PICTURE", "PORTAL", "SOURCE", "svg", "math", "CANVAS", "DEL", "INS", "BUTTON", "INPUT", "LABEL", "METER", "OUTPUT", "PROGRESS", "SELECT", "TEXTAREA", "ACRONYM", "BIG", "CONTENT", "FONT", "IMG", "MARQUEE", "MENUITEM", "NOBR", "SHADOW", "STRIKE", "TT"]);

// src/shared/plugins/html-deserializer/utils/isHtmlElement.ts
var _isHtmlElement = function _isHtmlElement(node) {
  return node.nodeType === Node.ELEMENT_NODE;
};

// src/shared/plugins/html-deserializer/utils/isHtmlInlineElement.ts
var _isHtmlInlineElement2 = function _isHtmlInlineElement(node) {
  if (!_isHtmlElement(node)) return false;
  var element = node;
  var tagNameIsInline = _inlineTagNames.has(element.tagName);
  var displayProperty = element.style.display.split(" ")[0];
  if (displayProperty === "") {
    return tagNameIsInline;
  }
  if (displayProperty.startsWith("inline")) {
    return true;
  }
  if (displayProperty === "inherit" && element.parentElement) {
    return _isHtmlInlineElement2(element.parentElement);
  }
  if (["contents", "initial", "none", "revert", "revert-layer", "unset"].includes(displayProperty)) {
    return tagNameIsInline;
  }
  return false;
};

// src/shared/plugins/html-deserializer/utils/isHtmlText.ts
var _isHtmlText = function _isHtmlText(node) {
  return node.nodeType === Node.TEXT_NODE;
};

// src/shared/plugins/html-deserializer/utils/isHtmlBlockElement.ts
var _isHtmlBlockElement = function _isHtmlBlockElement(node) {
  if (!_isHtmlElement(node)) return false;
  var element = node;
  return !_isHtmlInlineElement2(element);
};

// src/shared/plugins/html-deserializer/utils/collapse-white-space/isLastNonEmptyTextOfInlineFormattingContext.ts
var _isLastNonEmptyTextOfInlineFormattingContext = function _isLastNonEmptyTextOfInlineFormattingContext(initialText) {
  var currentNode = initialText;
  while (true) {
    if (currentNode.nextSibling) {
      currentNode = currentNode.nextSibling;
    } else {
      currentNode = currentNode.parentElement;
      if (currentNode && _isHtmlBlockElement(currentNode)) {
        return true;
      }
      currentNode = (currentNode == null ? void 0 : currentNode.nextSibling) || null;
    }
    if (!currentNode) {
      return true;
    }
    if (_isHtmlBlockElement(currentNode)) {
      return true;
    }
    if ((currentNode.textContent || "").length > 0) {
      return false;
    }
  }
};

// src/shared/plugins/html-deserializer/utils/collapse-white-space/stateTransforms.ts
var _upsertInlineFormattingContext = function _upsertInlineFormattingContext(state) {
  if (state.inlineFormattingContext) {
    state.inlineFormattingContext.atStart = false;
  } else {
    state.inlineFormattingContext = {
      atStart: true,
      lastHasTrailingWhiteSpace: false
    };
  }
};
var _endInlineFormattingContext = function _endInlineFormattingContext(state) {
  state.inlineFormattingContext = null;
};

// src/shared/plugins/html-deserializer/utils/collapse-white-space/collapseWhiteSpaceText.ts
var _collapseWhiteSpaceText = function _collapseWhiteSpaceText(text, state) {
  var textContent = text.textContent || "";
  var isWhiteSpaceOnly = textContent.trim() === "";
  if (state.inlineFormattingContext || !isWhiteSpaceOnly) {
    _upsertInlineFormattingContext(state);
  }
  var whiteSpaceRule = state.whiteSpaceRule;
  var trimStart = function () {
    if (whiteSpaceRule !== "normal") return "collapse";
    if (!state.inlineFormattingContext || state.inlineFormattingContext.atStart || state.inlineFormattingContext.lastHasTrailingWhiteSpace) return "all";
    return "collapse";
  }();
  var trimEnd = function () {
    if (whiteSpaceRule === "normal") return "collapse";
    if (_isLastNonEmptyTextOfInlineFormattingContext(text)) return "single-newline";
    return "collapse";
  }();
  var shouldCollapseWhiteSpace = {
    normal: true,
    pre: false,
    "pre-line": true
  }[whiteSpaceRule];
  var whiteSpaceIncludesNewlines = whiteSpaceRule !== "pre-line";
  var collapsedTextContent = _collapseString(textContent || "", {
    shouldCollapseWhiteSpace: shouldCollapseWhiteSpace,
    trimEnd: trimEnd,
    trimStart: trimStart,
    whiteSpaceIncludesNewlines: whiteSpaceIncludesNewlines
  });
  if (state.inlineFormattingContext && shouldCollapseWhiteSpace) {
    state.inlineFormattingContext.lastHasTrailingWhiteSpace = collapsedTextContent.endsWith(" ");
  }
  text.textContent = collapsedTextContent;
};

// src/shared/plugins/html-deserializer/utils/collapse-white-space/collapseWhiteSpaceNode.ts
var _collapseWhiteSpaceNode = function _collapseWhiteSpaceNode(node, state) {
  if (_isHtmlElement(node)) {
    _collapseWhiteSpaceElement(node, state);
    return;
  }
  if (_isHtmlText(node)) {
    _collapseWhiteSpaceText(node, state);
    return;
  }
  _collapseWhiteSpaceChildren(node, state);
};

// src/shared/plugins/html-deserializer/utils/collapse-white-space/collapseWhiteSpaceChildren.ts
var _collapseWhiteSpaceChildren = function _collapseWhiteSpaceChildren(node, state) {
  var childNodes = Array.from(node.childNodes);
  for (var _i2 = 0, _childNodes = childNodes; _i2 < _childNodes.length; _i2++) {
    var childNode = _childNodes[_i2];
    _collapseWhiteSpaceNode(childNode, state);
  }
};

// src/shared/plugins/html-deserializer/utils/collapse-white-space/inferWhiteSpaceRule.ts
var _inferWhiteSpaceRule = function _inferWhiteSpaceRule(element) {
  var whiteSpaceProperty = element.style.whiteSpace;
  switch (whiteSpaceProperty) {
    case "normal":
    case "nowrap":
      {
        return "normal";
      }
    case "pre":
    case "pre-wrap":
    case "break-spaces":
      {
        return "pre";
      }
    case "pre-line":
      {
        return "pre-line";
      }
  }
  if (element.tagName === "PRE") {
    return "pre";
  }
  if (whiteSpaceProperty === "initial") {
    return "normal";
  }
  return null;
};

// src/shared/plugins/html-deserializer/utils/collapse-white-space/collapseWhiteSpaceElement.ts
var _collapseWhiteSpaceElement = function _collapseWhiteSpaceElement(element, state) {
  var isInlineElement = _isHtmlInlineElement2(element);
  var previousWhiteSpaceRule = state.whiteSpaceRule;
  var inferredWhiteSpaceRule = _inferWhiteSpaceRule(element);
  if (inferredWhiteSpaceRule) {
    state.whiteSpaceRule = inferredWhiteSpaceRule;
  }
  if (!isInlineElement) {
    _endInlineFormattingContext(state);
  }
  _collapseWhiteSpaceChildren(element, state);
  if (!isInlineElement) {
    _endInlineFormattingContext(state);
  }
  state.whiteSpaceRule = previousWhiteSpaceRule;
};

// src/shared/plugins/html-deserializer/utils/collapse-white-space/collapseWhiteSpace.ts
var _collapseWhiteSpace = function _collapseWhiteSpace(element) {
  var clonedElement = element.cloneNode(true);
  var state = {
    inlineFormattingContext: null,
    whiteSpaceRule: "normal"
  };
  _collapseWhiteSpaceElement(clonedElement, state);
  return clonedElement;
};

// src/shared/plugins/html-deserializer/utils/htmlBodyToFragment.ts
var import_slate_hyperscript = require("slate-hyperscript");

// src/shared/plugins/html-deserializer/utils/deserializeHtmlNodeChildren.ts
var _deserializeHtmlNodeChildren = function _deserializeHtmlNodeChildren(editor, node) {
  return Array.from(node.childNodes).flatMap(_deserializeHtmlNode(editor));
};

// src/shared/plugins/html-deserializer/utils/htmlBodyToFragment.ts
var _htmlBodyToFragment = function _htmlBodyToFragment(editor, element) {
  if (element.nodeName === "BODY") {
    return (0, import_slate_hyperscript.jsx)("fragment", {}, _deserializeHtmlNodeChildren(editor, element));
  }
};

// src/shared/plugins/html-deserializer/utils/htmlBrToNewLine.ts
var _htmlBrToNewLine = function _htmlBrToNewLine(node) {
  if (node.nodeName === "BR") {
    return "\n";
  }
};

// src/shared/plugins/html-deserializer/utils/htmlElementToElement.ts
var import_slate_hyperscript2 = require("slate-hyperscript");

// src/shared/plugins/html-deserializer/utils/pluginDeserializeHtml.ts
var import_utils4 = require("@udecode/utils");
var import_castArray3 = __toESM(require("lodash/castArray.js"));
var _pluginDeserializeHtml = function _pluginDeserializeHtml(editor, plugin, _ref13) {
  var deserializeLeaf = _ref13.deserializeLeaf,
    el = _ref13.element;
  var _a;
  var deserializeHtml2 = plugin.deserializeHtml,
    isElementRoot = plugin.isElement,
    isLeafRoot = plugin.isLeaf,
    type = plugin.type;
  if (!deserializeHtml2) return;
  var attributeNames = deserializeHtml2.attributeNames,
    isElementRule = deserializeHtml2.isElement,
    isLeafRule = deserializeHtml2.isLeaf,
    query = deserializeHtml2.query,
    rules = deserializeHtml2.rules;
  var getNode = deserializeHtml2.getNode;
  var isElement4 = isElementRule || isElementRoot;
  var isLeaf = isLeafRule || isLeafRoot;
  if (!deserializeLeaf && !isElement4) {
    return;
  }
  if (deserializeLeaf && !isLeaf) {
    return;
  }
  if (rules) {
    var isValid = rules.some(function (_ref14) {
      var validAttribute = _ref14.validAttribute,
        validClassName = _ref14.validClassName,
        _ref14$validNodeName = _ref14.validNodeName,
        validNodeName = _ref14$validNodeName === void 0 ? "*" : _ref14$validNodeName,
        validStyle = _ref14.validStyle;
      var _a2;
      if (validNodeName) {
        var validNodeNames = (0, import_castArray3.default)(validNodeName);
        if (validNodeNames.length > 0 && !validNodeNames.includes(el.nodeName) && validNodeName !== "*") return false;
      }
      if (validClassName && !el.classList.contains(validClassName)) return false;
      if (validStyle) {
        for (var _i3 = 0, _Object$entries = Object.entries(validStyle); _i3 < _Object$entries.length; _i3++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          var values2 = (0, import_castArray3.default)(value);
          if (!values2.includes(el.style[key]) && value !== "*") return;
          if (value === "*" && !el.style[key]) return;
          var defaultNodeValue = (_a2 = plugin.inject.props) == null ? void 0 : _a2.defaultNodeValue;
          if (defaultNodeValue && defaultNodeValue === el.style[key]) {
            return false;
          }
        }
      }
      if (validAttribute) {
        if (typeof validAttribute === "string") {
          if (!el.getAttributeNames().includes(validAttribute)) return false;
        } else {
          for (var _i4 = 0, _Object$entries2 = Object.entries(validAttribute); _i4 < _Object$entries2.length; _i4++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2),
              attributeName = _Object$entries2$_i[0],
              attributeValue = _Object$entries2$_i[1];
            var attributeValues = (0, import_castArray3.default)(attributeValue);
            var elAttribute = el.getAttribute(attributeName);
            if (!(0, import_utils4.isDefined)(elAttribute) || !attributeValues.includes(elAttribute)) return false;
          }
        }
      }
      return true;
    });
    if (!isValid) return;
  }
  if (query && !query(el)) {
    return;
  }
  if (!getNode) {
    if (isElement4) {
      getNode = function getNode() {
        return {
          type: type
        };
      };
    } else if (isLeaf) {
      getNode = function getNode() {
        return _defineProperty({}, type, true);
      };
    } else {
      return;
    }
  }
  var node = (_a = getNode(el, {})) != null ? _a : {};
  if (Object.keys(node).length === 0) return;
  var injectedPlugins = _getInjectedPlugins(editor, plugin);
  injectedPlugins.forEach(function (injectedPlugin) {
    var _a2, _b;
    var res = (_b = (_a2 = injectedPlugin.deserializeHtml) == null ? void 0 : _a2.getNode) == null ? void 0 : _b.call(_a2, el, node);
    if (res) {
      node = __spreadValues(__spreadValues({}, node), res);
    }
  });
  if (attributeNames) {
    var elementAttributes = {};
    var elementAttributeNames = el.getAttributeNames();
    var _iterator4 = _createForOfIteratorHelper(elementAttributeNames),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var elementAttributeName = _step4.value;
        if (attributeNames.includes(elementAttributeName)) {
          elementAttributes[elementAttributeName] = el.getAttribute(elementAttributeName);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    if (Object.keys(elementAttributes).length > 0) {
      node.attributes = elementAttributes;
    }
  }
  return __spreadProps(__spreadValues({}, deserializeHtml2), {
    node: node
  });
};

// src/shared/plugins/html-deserializer/utils/pipeDeserializeHtmlElement.ts
var _pipeDeserializeHtmlElement = function _pipeDeserializeHtmlElement(editor, element) {
  var result;
  _toConsumableArray(editor.plugins).reverse().some(function (plugin) {
    result = _pluginDeserializeHtml(editor, plugin, {
      element: element
    });
    return !!result;
  });
  return result;
};

// src/shared/plugins/html-deserializer/utils/htmlElementToElement.ts
var _htmlElementToElement = function _htmlElementToElement(editor, element) {
  var _a;
  var deserialized = _pipeDeserializeHtmlElement(editor, element);
  if (deserialized) {
    var node = deserialized.node,
      withoutChildren = deserialized.withoutChildren;
    var descendants = (_a = node.children) != null ? _a : _deserializeHtmlNodeChildren(editor, element);
    if (descendants.length === 0 || withoutChildren) {
      descendants = [{
        text: ""
      }];
    }
    return (0, import_slate_hyperscript2.jsx)("element", node, descendants);
  }
};

// src/shared/plugins/html-deserializer/utils/htmlElementToLeaf.ts
var import_slate8 = require("@udecode/slate");
var import_slate_hyperscript3 = require("slate-hyperscript");

// src/shared/plugins/html-deserializer/utils/pipeDeserializeHtmlLeaf.ts
var _pipeDeserializeHtmlLeaf = function _pipeDeserializeHtmlLeaf(editor, element) {
  var node = {};
  _toConsumableArray(editor.plugins).reverse().forEach(function (plugin) {
    var deserialized = _pluginDeserializeHtml(editor, plugin, {
      deserializeLeaf: true,
      element: element
    });
    if (!deserialized) return;
    node = __spreadValues(__spreadValues({}, node), deserialized.node);
  });
  return node;
};

// src/shared/plugins/html-deserializer/utils/htmlElementToLeaf.ts
var _htmlElementToLeaf = function _htmlElementToLeaf(editor, element) {
  var node = _pipeDeserializeHtmlLeaf(editor, element);
  return _deserializeHtmlNodeChildren(editor, element).reduce(function (arr, child) {
    if (!child) return arr;
    if ((0, import_slate8.isElement)(child)) {
      if (Object.keys(node).length > 0) {
        _mergeDeepToNodes({
          node: child,
          query: {
            filter: function filter(_ref16) {
              var _ref17 = _slicedToArray(_ref16, 1),
                n = _ref17[0];
              return (0, import_slate8.isText)(n);
            }
          },
          source: node
        });
      }
      arr.push(child);
    } else {
      var attributes = __spreadValues({}, node);
      if ((0, import_slate8.isText)(child) && child.text) {
        Object.keys(attributes).forEach(function (key) {
          if (attributes[key] && child[key]) {
            attributes[key] = child[key];
          }
        });
      }
      arr.push((0, import_slate_hyperscript3.jsx)("text", attributes, child));
    }
    return arr;
  }, []);
};

// src/shared/plugins/html-deserializer/utils/htmlTextNodeToString.ts
var _htmlTextNodeToString = function _htmlTextNodeToString(node) {
  if (_isHtmlText(node)) {
    return node.textContent || "";
  }
};

// src/shared/plugins/html-deserializer/utils/deserializeHtmlNode.ts
var _deserializeHtmlNode = function _deserializeHtmlNode(editor) {
  return function (node) {
    var textNode = _htmlTextNodeToString(node);
    if (textNode) return textNode;
    if (!_isHtmlElement(node)) return null;
    var breakLine = _htmlBrToNewLine(node);
    if (breakLine) return breakLine;
    var fragment = _htmlBodyToFragment(editor, node);
    if (fragment) return fragment;
    var element = _htmlElementToElement(editor, node);
    if (element) return element;
    return _htmlElementToLeaf(editor, node);
  };
};

// src/shared/plugins/html-deserializer/utils/deserializeHtmlElement.ts
var _deserializeHtmlElement = function _deserializeHtmlElement(editor, element) {
  return _deserializeHtmlNode(editor)(element);
};

// src/shared/plugins/html-deserializer/utils/htmlStringToDOMNode.ts
var _htmlStringToDOMNode = function _htmlStringToDOMNode(rawHtml) {
  var node = document.createElement("body");
  node.innerHTML = rawHtml;
  return node;
};

// src/shared/plugins/html-deserializer/utils/deserializeHtml.ts
var _deserializeHtml = function _deserializeHtml(editor, _ref18) {
  var _ref18$collapseWhiteS = _ref18.collapseWhiteSpace,
    shouldCollapseWhiteSpace = _ref18$collapseWhiteS === void 0 ? true : _ref18$collapseWhiteS,
    element = _ref18.element;
  if (typeof element === "string") {
    element = _htmlStringToDOMNode(element);
  }
  if (shouldCollapseWhiteSpace) {
    element = _collapseWhiteSpace(element);
  }
  var fragment = _deserializeHtmlElement(editor, element);
  return _normalizeDescendantsToDocumentFragment(editor, {
    descendants: fragment
  });
};

// src/shared/plugins/html-deserializer/utils/parseHtmlDocument.ts
var _parseHtmlDocument = function _parseHtmlDocument(html) {
  return new DOMParser().parseFromString(html, "text/html");
};

// src/shared/plugins/html-deserializer/createDeserializeHtmlPlugin.ts
var _KEY_DESERIALIZE_HTML = "deserializeHtml";
var _createDeserializeHtmlPlugin = _createPluginFactory({
  key: _KEY_DESERIALIZE_HTML,
  then: function then(editor) {
    return {
      editor: {
        insertData: {
          format: "text/html",
          getFragment: function getFragment(_ref19) {
            var data = _ref19.data;
            var document2 = _parseHtmlDocument(data);
            return _deserializeHtml(editor, {
              element: document2.body
            });
          }
        }
      }
    };
  }
});

// src/shared/plugins/html-deserializer/utils/traverseHtmlNode.ts
var _traverseHtmlNode2 = function _traverseHtmlNode(node, callback) {
  var keepTraversing = callback(node);
  if (!keepTraversing) {
    return;
  }
  var child = node.firstChild;
  while (child) {
    var currentChild = child;
    var previousChild = child.previousSibling;
    child = child.nextSibling;
    _traverseHtmlNode2(currentChild, callback);
    if (
    // An unwrap was made. Need to compute the next child again.
    !currentChild.previousSibling && !currentChild.nextSibling && !currentChild.parentNode && child && previousChild !== child.previousSibling && child.parentNode) {
      child = previousChild ? previousChild.nextSibling : node.firstChild;
    } else if (
    // A list was created. Need to compute the next child again.
    !currentChild.previousSibling && !currentChild.nextSibling && !currentChild.parentNode && child && !child.previousSibling && !child.nextSibling && !child.parentNode) {
      if (previousChild) {
        child = previousChild.nextSibling ? previousChild.nextSibling.nextSibling : null;
      } else if (node.firstChild) {
        child = node.firstChild.nextSibling;
      }
    }
  }
};

// src/shared/plugins/html-deserializer/utils/traverseHtmlElements.ts
var _traverseHtmlElements = function _traverseHtmlElements(rootNode, callback) {
  _traverseHtmlNode2(rootNode, function (node) {
    if (!_isHtmlElement(node)) {
      return true;
    }
    return callback(node);
  });
};

// src/shared/plugins/html-deserializer/utils/cleanHtmlBrElements.ts
var _cleanHtmlBrElements = function _cleanHtmlBrElements(rootNode) {
  _traverseHtmlElements(rootNode, function (element) {
    if (element.tagName !== "BR") {
      return true;
    }
    var replacementTextNode = document.createTextNode(_LINE_FEED);
    if (element.parentElement) {
      element.parentElement.replaceChild(replacementTextNode, element);
    }
    return false;
  });
};

// src/shared/plugins/html-deserializer/utils/cleanHtmlCrLf.ts
var _cleanHtmlCrLf = function _cleanHtmlCrLf(html) {
  return html.replaceAll(/\r\n|\r/g, "\n");
};

// src/shared/plugins/html-deserializer/utils/cleanHtmlEmptyElements.ts
var ALLOWED_EMPTY_ELEMENTS = /* @__PURE__ */new Set(["BR", "IMG", "TH", "TD"]);
var isEmpty = function isEmpty(element) {
  return !ALLOWED_EMPTY_ELEMENTS.has(element.nodeName) && !element.innerHTML.trim();
};
var _removeIfEmpty = function removeIfEmpty(element) {
  if (isEmpty(element)) {
    var parentElement = element.parentElement;
    element.remove();
    if (parentElement) {
      _removeIfEmpty(parentElement);
    }
  }
};
var _cleanHtmlEmptyElements = function _cleanHtmlEmptyElements(rootNode) {
  _traverseHtmlElements(rootNode, function (element) {
    _removeIfEmpty(element);
    return true;
  });
};

// src/shared/plugins/html-deserializer/utils/replaceTagName.ts
var _replaceTagName = function _replaceTagName(element, tagName) {
  var newElement = document.createElement(tagName);
  newElement.innerHTML = element.innerHTML;
  var _iterator5 = _createForOfIteratorHelper(element.attributes),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var name = _step5.value.name;
      var value = element.getAttribute(name);
      if (value) {
        newElement.setAttribute(name, value);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  if (element.parentNode) {
    element.parentNode.replaceChild(newElement, element);
  }
  return newElement;
};

// src/shared/plugins/html-deserializer/utils/cleanHtmlFontElements.ts
var _cleanHtmlFontElements = function _cleanHtmlFontElements(rootNode) {
  _traverseHtmlElements(rootNode, function (element) {
    if (element.tagName === "FONT") {
      if (element.textContent) {
        _replaceTagName(element, "span");
      } else {
        element.remove();
      }
    }
    return true;
  });
};

// src/shared/plugins/html-deserializer/utils/isHtmlFragmentHref.ts
var _isHtmlFragmentHref = function _isHtmlFragmentHref(href) {
  return href.startsWith("#");
};

// src/shared/plugins/html-deserializer/utils/unwrapHtmlElement.ts
var _unwrapHtmlElement = function _unwrapHtmlElement(element) {
  element.outerHTML = element.innerHTML;
};

// src/shared/plugins/html-deserializer/utils/cleanHtmlLinkElements.ts
var _cleanHtmlLinkElements = function _cleanHtmlLinkElements(rootNode) {
  _traverseHtmlElements(rootNode, function (element) {
    if (element.tagName !== "A") {
      return true;
    }
    var href = element.getAttribute("href");
    if (!href || _isHtmlFragmentHref(href)) {
      _unwrapHtmlElement(element);
    }
    if (href && element.querySelector("img")) {
      var _iterator6 = _createForOfIteratorHelper(element.querySelectorAll("span")),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var span = _step6.value;
          if (!span.textContent) {
            _unwrapHtmlElement(span);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    return true;
  });
};

// src/shared/plugins/html-deserializer/utils/traverseHtmlTexts.ts
var _traverseHtmlTexts = function _traverseHtmlTexts(rootNode, callback) {
  _traverseHtmlNode2(rootNode, function (node) {
    if (!_isHtmlText(node)) {
      return true;
    }
    return callback(node);
  });
};

// src/shared/plugins/html-deserializer/utils/cleanHtmlTextNodes.ts
var _cleanHtmlTextNodes = function _cleanHtmlTextNodes(rootNode) {
  _traverseHtmlTexts(rootNode, function (textNode) {
    if (/^\n\s*$/.test(textNode.data) && (textNode.previousElementSibling || textNode.nextElementSibling)) {
      textNode.remove();
      return true;
    }
    textNode.data = textNode.data.replaceAll(/\n\s*/g, "\n");
    if (textNode.data.includes(_CARRIAGE_RETURN) || textNode.data.includes(_LINE_FEED) || textNode.data.includes(_NO_BREAK_SPACE)) {
      var hasSpace = textNode.data.includes(_SPACE);
      var hasNonWhitespace = /\S/.test(textNode.data);
      var hasLineFeed = textNode.data.includes(_LINE_FEED);
      if (!(hasSpace || hasNonWhitespace) && !hasLineFeed) {
        if (textNode.data === _NO_BREAK_SPACE) {
          textNode.data = _SPACE;
          return true;
        }
        textNode.remove();
        return true;
      }
      if (textNode.previousSibling && textNode.previousSibling.nodeName === "BR" && textNode.parentElement) {
        textNode.previousSibling.remove();
        var matches = textNode.data.match(/^[\n\r]+/);
        var offset = matches ? matches[0].length : 0;
        textNode.data = textNode.data.slice(Math.max(0, offset)).replaceAll(new RegExp(_LINE_FEED, "g"), _SPACE).replaceAll(new RegExp(_CARRIAGE_RETURN, "g"), _SPACE);
        textNode.data = "\n".concat(textNode.data);
      } else {
        textNode.data = textNode.data.replaceAll(new RegExp(_LINE_FEED, "g"), _SPACE).replaceAll(new RegExp(_CARRIAGE_RETURN, "g"), _SPACE);
      }
    }
    return true;
  });
};

// src/shared/plugins/html-deserializer/utils/isHtmlTable.ts
var _isHtmlTable = function _isHtmlTable(element) {
  return element.nodeName === "TABLE";
};

// src/shared/plugins/html-deserializer/utils/copyBlockMarksToSpanChild.ts
var _copyBlockMarksToSpanChild = function _copyBlockMarksToSpanChild(rootNode) {
  _traverseHtmlElements(rootNode, function (element) {
    var el = element;
    var styleAttribute = element.getAttribute("style");
    if (!styleAttribute) return true;
    if (_isHtmlBlockElement(el) && !_isHtmlTable(el)) {
      var _el$style = el.style,
        backgroundColor = _el$style.backgroundColor,
        color = _el$style.color,
        fontFamily = _el$style.fontFamily,
        fontSize = _el$style.fontSize,
        fontStyle = _el$style.fontStyle,
        fontWeight = _el$style.fontWeight,
        textDecoration = _el$style.textDecoration;
      if (backgroundColor || color || fontFamily || fontSize || fontStyle || fontWeight || textDecoration) {
        var span = document.createElement("span");
        if (!["inherit", "initial"].includes(color)) {
          span.style.color = color;
        }
        span.style.fontFamily = fontFamily;
        span.style.fontSize = fontSize;
        if (!["inherit", "initial", "normal"].includes(color)) {
          span.style.fontStyle = fontStyle;
        }
        if (![400, "normal"].includes(fontWeight)) {
          span.style.fontWeight = fontWeight;
        }
        span.style.textDecoration = textDecoration;
        span.innerHTML = el.innerHTML;
        element.innerHTML = span.outerHTML;
      }
    }
    return true;
  });
};

// src/shared/plugins/html-deserializer/utils/findHtmlElement.ts
var _findHtmlElement = function _findHtmlElement(rootNode, predicate) {
  var res = null;
  _traverseHtmlElements(rootNode, function (node) {
    if (predicate(node)) {
      res = node;
      return false;
    }
    return true;
  });
  return res;
};
var _someHtmlElement = function _someHtmlElement(rootNode, predicate) {
  return !!_findHtmlElement(rootNode, predicate);
};

// src/shared/plugins/html-deserializer/utils/getHtmlComments.ts
var acceptNode = function acceptNode() {
  return NodeFilter.FILTER_ACCEPT;
};
var _getHtmlComments = function _getHtmlComments(node) {
  var comments = [];
  var iterator = document.createNodeIterator(node, NodeFilter.SHOW_COMMENT, {
    acceptNode: acceptNode
  });
  var currentNode = iterator.nextNode();
  while (currentNode) {
    if (currentNode.nodeValue) {
      comments.push(currentNode.nodeValue);
    }
    currentNode = iterator.nextNode();
  }
  return comments;
};

// src/shared/plugins/html-deserializer/utils/isHtmlComment.ts
var _isHtmlComment = function _isHtmlComment(node) {
  return node.nodeType === Node.COMMENT_NODE;
};

// src/shared/plugins/html-deserializer/utils/isOlSymbol.ts
var _isOlSymbol = function _isOlSymbol(symbol) {
  return /[\da-np-z]\S/.test(symbol.toLowerCase());
};

// src/shared/plugins/html-deserializer/utils/parseHtmlElement.ts
var _parseHtmlElement = function _parseHtmlElement(html) {
  var _parseHtmlDocument2 = _parseHtmlDocument(html),
    body = _parseHtmlDocument2.body;
  return body.firstElementChild;
};

// src/shared/plugins/html-deserializer/utils/postCleanHtml.ts
var _postCleanHtml = function _postCleanHtml(html) {
  var cleanHtml = html.trim().replaceAll(new RegExp(_ZERO_WIDTH_SPACE, "g"), "");
  return "<body>".concat(cleanHtml, "</body>");
};

// src/shared/plugins/html-deserializer/utils/removeHtmlSurroundings.ts
var removeBeforeHtml = function removeBeforeHtml(html) {
  var index = html.indexOf("<html");
  if (index === -1) {
    return html;
  }
  return html.slice(Math.max(0, index));
};
var removeAfterHtml = function removeAfterHtml(html) {
  var index = html.lastIndexOf("</html>");
  if (index === -1) {
    return html;
  }
  return html.slice(0, Math.max(0, index + "</html>".length));
};
var _removeHtmlSurroundings = function _removeHtmlSurroundings(html) {
  return removeBeforeHtml(removeAfterHtml(html));
};

// src/shared/plugins/html-deserializer/utils/preCleanHtml.ts
var cleaners = [_removeHtmlSurroundings, _cleanHtmlCrLf];
var _preCleanHtml = function _preCleanHtml(html) {
  return cleaners.reduce(function (result, clean) {
    return clean(result);
  }, html);
};

// src/shared/plugins/html-deserializer/utils/traverseHtmlComments.ts
var _traverseHtmlComments = function _traverseHtmlComments(rootNode, callback) {
  _traverseHtmlNode2(rootNode, function (node) {
    if (!_isHtmlComment(node)) {
      return true;
    }
    return callback(node);
  });
};

// src/shared/plugins/html-deserializer/utils/removeHtmlNodesBetweenComments.ts
var _removeHtmlNodesBetweenComments = function _removeHtmlNodesBetweenComments(rootNode, start, end) {
  var isClosingComment = function isClosingComment(node) {
    return _isHtmlComment(node) && node.data === end;
  };
  _traverseHtmlComments(rootNode, function (comment) {
    if (comment.data === start) {
      var node = comment.nextSibling;
      comment.remove();
      while (node && !isClosingComment(node)) {
        var _node = node,
          nextSibling = _node.nextSibling;
        node.remove();
        node = nextSibling;
      }
      if (node && isClosingComment(node)) {
        node.remove();
      }
    }
    return true;
  });
};

// src/client/plugins/event-editor/useFocusEditorEvents.ts
var import_react2 = require("react");
var _useFocusEditorEvents = function _useFocusEditorEvents(_ref20) {
  var editorRef = _ref20.editorRef,
    onEditorBlur = _ref20.onEditorBlur,
    onEditorFocus = _ref20.onEditorFocus;
  (0, import_react2.useEffect)(function () {
    var onFocusEditor = function onFocusEditor(event) {
      var id = event.detail.id;
      if (!!onEditorFocus && editorRef && editorRef.id === id) {
        onEditorFocus();
      }
    };
    var onBlurEditor = function onBlurEditor(event) {
      var id = event.detail.id;
      if (!!onEditorBlur && editorRef && editorRef.id === id) {
        onEditorBlur();
      }
    };
    document.addEventListener(_FOCUS_EDITOR_EVENT, onFocusEditor);
    document.addEventListener(_BLUR_EDITOR_EVENT, onBlurEditor);
    return function () {
      document.removeEventListener(_FOCUS_EDITOR_EVENT, onFocusEditor);
      document.removeEventListener(_BLUR_EDITOR_EVENT, onBlurEditor);
    };
  }, [editorRef, onEditorBlur, onEditorFocus]);
};

// src/client/plugins/react/withTReact.ts
var import_slate_react = require("@udecode/slate-react");
var import_slate_react2 = require("slate-react");
var _withTReact = function _withTReact(editor) {
  var e = (0, import_slate_react2.withReact)(editor);
  var reset = e.reset;
  e.reset = function () {
    var isFocused = (0, import_slate_react.isEditorFocused)(editor);
    reset();
    if (isFocused) {
      (0, import_slate_react.focusEditorEdge)(editor, {
        edge: "start"
      });
    }
  };
  return e;
};

// src/client/plugins/react/createReactPlugin.ts
var _KEY_REACT = "react";
var _createReactPlugin = _createPluginFactory({
  key: _KEY_REACT,
  withOverrides: _withTReact
});

// src/client/utils/setPlatePlugins.ts
var _setPlatePlugins = function _setPlatePlugins(editor, _ref21) {
  var disableCorePlugins = _ref21.disableCorePlugins,
    maxLength = _ref21.maxLength,
    _ref21$plugins = _ref21.plugins,
    _plugins = _ref21$plugins === void 0 ? [] : _ref21$plugins;
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  var plugins = [];
  if (disableCorePlugins !== true) {
    var dcp = disableCorePlugins;
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.react)) {
      plugins.push((_b = (_a = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _a.react) != null ? _b : _createReactPlugin());
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.history)) {
      plugins.push((_d = (_c = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _c.history) != null ? _d : _createHistoryPlugin());
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.nodeFactory)) {
      plugins.push((_f = (_e = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _e[_KEY_NODE_FACTORY]) != null ? _f : _createNodeFactoryPlugin());
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.eventEditor)) {
      plugins.push((_h = (_g = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _g[_KEY_EVENT_EDITOR]) != null ? _h : _createEventEditorPlugin());
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.inlineVoid)) {
      plugins.push((_j = (_i = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _i[_KEY_INLINE_VOID]) != null ? _j : _createInlineVoidPlugin());
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.insertData)) {
      plugins.push((_l = (_k = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _k[_KEY_INSERT_DATA]) != null ? _l : _createInsertDataPlugin());
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.selection)) {
      plugins.push((_n = (_m = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _m[_KEY_PREV_SELECTION]) != null ? _n : _createPrevSelectionPlugin());
    }
    if ((typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.length)) && (0, import_utils6.isDefined)(maxLength)) {
      plugins.push((_p = (_o = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _o[_KEY_LENGTH]) != null ? _p : _createLengthPlugin({
        options: {
          maxLength: maxLength
        }
      }));
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.deserializeHtml)) {
      plugins.push((_r = (_q = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _q[_KEY_DESERIALIZE_HTML]) != null ? _r : _createDeserializeHtmlPlugin());
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.deserializeAst)) {
      plugins.push((_t = (_s = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _s[_KEY_DESERIALIZE_AST]) != null ? _t : _createDeserializeAstPlugin());
    }
    if (typeof dcp !== "object" || !(dcp == null ? void 0 : dcp.editorProtocol)) {
      plugins.push((_v = (_u = editor == null ? void 0 : editor.pluginsByKey) == null ? void 0 : _u[_KEY_EDITOR_PROTOCOL]) != null ? _v : _createEditorProtocolPlugin());
    }
  }
  plugins = [].concat(_toConsumableArray(plugins), _toConsumableArray(_plugins));
  editor.plugins = [];
  editor.pluginsByKey = {};
  _flattenDeepPlugins2(editor, plugins);
  editor.plugins.forEach(function (plugin) {
    if (plugin.overrideByKey) {
      var newPlugins = editor.plugins.map(function (p) {
        return _overridePluginsByKey2(p, plugin.overrideByKey);
      });
      editor.plugins = [];
      editor.pluginsByKey = {};
      _flattenDeepPlugins2(editor, newPlugins);
    }
  });
};

// src/client/plugins/withPlate.ts
var shouldHaveBeenOverridden = function shouldHaveBeenOverridden(fnName) {
  return function () {
    console.warn("editor.".concat(fnName, " should have been overriden but was not. Please report this issue here: https://github.com/udecode/plate/issues"));
  };
};
var _withPlate = function _withPlate(e) {
  var _ref22 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    disableCorePlugins = _ref22.disableCorePlugins,
    id = _ref22.id,
    maxLength = _ref22.maxLength,
    _ref22$plugins = _ref22.plugins,
    plugins = _ref22$plugins === void 0 ? [] : _ref22$plugins;
  var editor = e;
  editor.id = id != null ? id : editor.id;
  editor.prevSelection = null;
  editor.isFallback = false;
  editor.currentKeyboardEvent = null;
  editor.reset = function () {
    return _resetEditor(editor);
  };
  editor.redecorate = function () {
    return shouldHaveBeenOverridden("redecorate");
  };
  editor.plate = {
    get set() {
      shouldHaveBeenOverridden("plate.set");
      return null;
    }
  };
  if (!editor.key) {
    editor.key = Math.random();
  }
  _setPlatePlugins(editor, {
    disableCorePlugins: disableCorePlugins,
    maxLength: maxLength,
    plugins: plugins
  });
  editor.plugins.forEach(function (plugin) {
    if (plugin.withOverrides) {
      editor = plugin.withOverrides(editor, plugin);
    }
  });
  return editor;
};

// src/client/utils/createPlateEditor.ts
var _createPlateEditor = function _createPlateEditor() {
  var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _b = _a,
    components = _b.components,
    _b$editor = _b.editor,
    editor = _b$editor === void 0 ? (0, import_slate9.createTEditor)() : _b$editor,
    shouldNormalizeInitialValue = _b.normalizeInitialValue,
    overrideByKey = _b.overrideByKey,
    _b$plugins = _b.plugins,
    plugins = _b$plugins === void 0 ? [] : _b$plugins,
    withPlateOptions = __objRest(_b, ["components", "editor", "normalizeInitialValue", "overrideByKey", "plugins"]);
  plugins = _createPlugins(plugins, {
    components: components,
    overrideByKey: overrideByKey
  });
  var e = _withPlate(editor, __spreadValues({
    plugins: plugins
  }, withPlateOptions));
  if (shouldNormalizeInitialValue) {
    (0, import_slate9.normalizeEditor)(e, {
      force: true
    });
  }
  return e;
};

// src/client/utils/createPlateFallbackEditor.ts
var _createPlateFallbackEditor = function _createPlateFallbackEditor() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var editor = _createPlateEditor(options);
  editor.isFallback = true;
  editor.apply = function () {
    throw new Error("Cannot apply operations on the fallback editor. The fallback editor is used when a hook that depends on the Plate store was unable to locate a valid store. If you are using PlateController, use `useEditorMounted(id?: PlateId)` or `!editor.isFallback` to ensure that a valid Plate store is available before attempting to call operations on the editor.");
  };
  return editor;
};

// src/client/utils/hotkeys.ts
var import_slate_react3 = require("@udecode/slate-react");
var createComposing = function createComposing(key) {
  return function (editor, event) {
    var _ref23 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      composing = _ref23.composing;
    if (!_createHotkey(key)(event)) return false;
    if (!!composing !== (0, import_slate_react3.isComposing)(editor)) return false;
    return true;
  };
};
var _Hotkeys = __spreadProps(__spreadValues({}, _sharedHotkeys), {
  isTab: createComposing("tab"),
  isUntab: createComposing("untab")
});

// src/client/utils/pipeRenderElement.tsx
var import_react4 = __toESM(require("react"));
var import_slate_react5 = require("slate-react");

// src/client/utils/pluginRenderElement.tsx
var import_react3 = __toESM(require("react"));
var import_slate_react4 = require("slate-react");
var _pluginRenderElement = function _pluginRenderElement(editor, _ref24) {
  var _component = _ref24.component,
    dangerouslyAllowAttributes = _ref24.dangerouslyAllowAttributes,
    key = _ref24.key,
    props = _ref24.props,
    type = _ref24.type;
  return function render(nodeProps) {
    var _nodeProps2 = nodeProps,
      _children = _nodeProps2.children,
      element = _nodeProps2.element;
    if (element.type === type) {
      var Element = _component != null ? _component : import_slate_react4.DefaultElement;
      var injectAboveComponents = editor.plugins.flatMap(function (o) {
        var _a, _b;
        return (_b = (_a = o.inject) == null ? void 0 : _a.aboveComponent) != null ? _b : [];
      });
      var injectBelowComponents = editor.plugins.flatMap(function (o) {
        var _a, _b;
        return (_b = (_a = o.inject) == null ? void 0 : _a.belowComponent) != null ? _b : [];
      });
      nodeProps = _getRenderNodeProps({
        attributes: element.attributes,
        dangerouslyAllowAttributes: dangerouslyAllowAttributes,
        nodeProps: nodeProps,
        props: props,
        type: type
      });
      var children = _children;
      injectBelowComponents.forEach(function (withHOC2) {
        var hoc = withHOC2(__spreadProps(__spreadValues({}, nodeProps), {
          key: key
        }));
        if (hoc) {
          children = hoc(__spreadProps(__spreadValues({}, nodeProps), {
            children: children
          }));
        }
      });
      var component = /* @__PURE__ */import_react3.default.createElement(Element, __spreadValues({}, nodeProps), children);
      injectAboveComponents.forEach(function (withHOC2) {
        var hoc = withHOC2(__spreadProps(__spreadValues({}, nodeProps), {
          key: key
        }));
        if (hoc) {
          component = hoc(__spreadProps(__spreadValues({}, nodeProps), {
            children: component
          }));
        }
      });
      return /* @__PURE__ */import_react3.default.createElement(_ElementProvider, {
        element: element,
        scope: key
      }, component);
    }
  };
};

// src/client/utils/pipeRenderElement.tsx
var _pipeRenderElement = function _pipeRenderElement(editor, renderElementProp) {
  var renderElements = [];
  editor.plugins.forEach(function (plugin) {
    if (plugin.isElement) {
      renderElements.push(_pluginRenderElement(editor, plugin));
    }
  });
  return function render(nodeProps) {
    var props = _pipeInjectProps(editor, nodeProps);
    var element;
    renderElements.some(function (renderElement) {
      element = renderElement(props);
      return !!element;
    });
    if (element) return element;
    if (renderElementProp) {
      return renderElementProp(props);
    }
    return /* @__PURE__ */import_react4.default.createElement(import_slate_react5.DefaultElement, __spreadValues({}, props));
  };
};

// src/client/utils/pipeRenderLeaf.tsx
var import_react7 = __toESM(require("react"));

// src/shared/components/DefaultLeaf.tsx
var import_react5 = __toESM(require("react"));
function _DefaultLeaf(_a) {
  var _b = _a,
    attributes = _b.attributes,
    children = _b.children,
    editor = _b.editor,
    leaf = _b.leaf,
    nodeProps = _b.nodeProps,
    text = _b.text,
    props = __objRest(_b, ["attributes", "children", "editor", "leaf", "nodeProps", "text"]);
  return /* @__PURE__ */import_react5.default.createElement("span", __spreadValues(__spreadValues({}, attributes), props), children);
}

// src/shared/types/misc/dom-attributes.ts
var _DOM_HANDLERS = [
// Clipboard Events
"onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture",
// Composition Events
"onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture",
// Focus Events
"onFocus", "onFocusCapture", "onBlur", "onBlurCapture",
// Form Events
"onDOMBeforeInput", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture",
// Image Events
"onLoad", "onLoadCapture",
// Keyboard Events
"onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture",
// Media Events
"onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture",
// MouseEvents
"onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture",
// Selection Events
"onSelect", "onSelectCapture",
// Touch Events
"onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture",
// Pointer Events
"onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerLeave", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture",
// UI Events
"onScroll", "onScrollCapture",
// Wheel Events
"onWheel", "onWheelCapture",
// Animation Events
"onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture",
// Transition Events
"onTransitionEnd", "onTransitionEndCapture"];

// src/client/utils/pluginRenderLeaf.tsx
var import_react6 = __toESM(require("react"));
var _pluginRenderLeaf = function _pluginRenderLeaf(editor, _ref25) {
  var component = _ref25.component,
    dangerouslyAllowAttributes = _ref25.dangerouslyAllowAttributes,
    key = _ref25.key,
    props = _ref25.props,
    _ref25$type = _ref25.type,
    type = _ref25$type === void 0 ? key : _ref25$type;
  return function render(nodeProps) {
    var _nodeProps3 = nodeProps,
      children = _nodeProps3.children,
      leaf = _nodeProps3.leaf;
    if (leaf[type]) {
      var Leaf = component != null ? component : _DefaultLeaf;
      nodeProps = _getRenderNodeProps({
        attributes: leaf.attributes,
        dangerouslyAllowAttributes: dangerouslyAllowAttributes,
        nodeProps: nodeProps,
        props: props,
        type: type
      });
      return /* @__PURE__ */import_react6.default.createElement(Leaf, __spreadValues({}, nodeProps), children);
    }
    return children;
  };
};

// src/client/utils/pipeRenderLeaf.tsx
var _pipeRenderLeaf = function _pipeRenderLeaf(editor, renderLeafProp) {
  var renderLeafs = [];
  editor.plugins.forEach(function (plugin) {
    if (plugin.isLeaf && plugin.key) {
      renderLeafs.push(_pluginRenderLeaf(editor, plugin));
    }
  });
  return function render(nodeProps) {
    var props = _pipeInjectProps(editor, nodeProps);
    renderLeafs.forEach(function (renderLeaf) {
      var newChildren = renderLeaf(props);
      if (newChildren !== void 0) {
        props.children = newChildren;
      }
    });
    if (renderLeafProp) {
      return renderLeafProp(props);
    }
    return /* @__PURE__ */import_react7.default.createElement(_DefaultLeaf, __spreadValues({}, props));
  };
};

// src/client/stores/plate-controller/plateControllerStore.ts
var import_react8 = __toESM(require("react"));
var import_jotai3 = require("jotai");
var _ref26 = (0, import_jotai_x.createAtomStore)({
    activeId: (0, import_jotai3.atom)(null),
    editorStores: (0, import_jotai3.atom)({}),
    primaryEditorIds: (0, import_jotai3.atom)([])
  }, {
    name: "plateController"
  }),
  _PlateController = _ref26.PlateControllerProvider,
  _plateControllerStore = _ref26.plateControllerStore,
  _usePlateControllerStore = _ref26.usePlateControllerStore;
var _usePlateControllerSelectors = function _usePlateControllerSelectors() {
  return _usePlateControllerStore().get;
};
var _usePlateControllerActions = function _usePlateControllerActions() {
  return _usePlateControllerStore().set;
};
var _usePlateControllerStates = function _usePlateControllerStates() {
  return _usePlateControllerStore().use;
};
var _usePlateControllerExists = function _usePlateControllerExists() {
  return !!_usePlateControllerStore().store({
    warnIfNoStore: false
  });
};
var _usePlateControllerEditorStore = function _usePlateControllerEditorStore(idProp) {
  var storeAtom = import_react8.default.useMemo(function () {
    return (0, import_jotai3.atom)(function (get) {
      var editorStores = get(_plateControllerStore.atom.editorStores);
      var forId = function forId(id) {
        var _a;
        if (!id) return null;
        return (_a = editorStores[id]) != null ? _a : null;
      };
      if (idProp) return forId(idProp);
      var lookupOrder = [get(_plateControllerStore.atom.activeId)].concat(_toConsumableArray(get(_plateControllerStore.atom.primaryEditorIds)));
      var _iterator7 = _createForOfIteratorHelper(lookupOrder),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var id = _step7.value;
          var store = forId(id);
          if (store) return store;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return null;
    });
  }, [idProp]);
  return _usePlateControllerSelectors().atom(storeAtom);
};

// src/client/stores/plate/createPlateStore.ts
var _PLATE_SCOPE = "plate";
var _GLOBAL_PLATE_SCOPE = Symbol("global-plate");
var _createPlateStore = function _createPlateStore() {
  var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _b = _a,
    _b$decorate = _b.decorate,
    decorate = _b$decorate === void 0 ? null : _b$decorate,
    _b$editor2 = _b.editor,
    editor = _b$editor2 === void 0 ? _createPlateFallbackEditor() : _b$editor2,
    _b$editorRef = _b.editorRef,
    editorRef = _b$editorRef === void 0 ? null : _b$editorRef,
    id = _b.id,
    _b$isMounted = _b.isMounted,
    isMounted = _b$isMounted === void 0 ? false : _b$isMounted,
    _b$onChange = _b.onChange,
    onChange = _b$onChange === void 0 ? null : _b$onChange,
    _b$onSelectionChange = _b.onSelectionChange,
    onSelectionChange = _b$onSelectionChange === void 0 ? null : _b$onSelectionChange,
    _b$onValueChange = _b.onValueChange,
    onValueChange = _b$onValueChange === void 0 ? null : _b$onValueChange,
    _b$plugins2 = _b.plugins,
    plugins = _b$plugins2 === void 0 ? [] : _b$plugins2,
    _b$primary = _b.primary,
    primary = _b$primary === void 0 ? true : _b$primary,
    _b$rawPlugins = _b.rawPlugins,
    rawPlugins = _b$rawPlugins === void 0 ? [] : _b$rawPlugins,
    _b$readOnly = _b.readOnly,
    readOnly = _b$readOnly === void 0 ? null : _b$readOnly,
    _b$renderElement = _b.renderElement,
    renderElement = _b$renderElement === void 0 ? null : _b$renderElement,
    _b$renderLeaf = _b.renderLeaf,
    renderLeaf = _b$renderLeaf === void 0 ? null : _b$renderLeaf,
    _b$value = _b.value,
    value = _b$value === void 0 ? null : _b$value,
    _b$versionDecorate = _b.versionDecorate,
    versionDecorate = _b$versionDecorate === void 0 ? 1 : _b$versionDecorate,
    _b$versionEditor = _b.versionEditor,
    versionEditor = _b$versionEditor === void 0 ? 1 : _b$versionEditor,
    _b$versionSelection = _b.versionSelection,
    versionSelection = _b$versionSelection === void 0 ? 1 : _b$versionSelection,
    state = __objRest(_b, ["decorate", "editor", "editorRef", "id", "isMounted", "onChange", "onSelectionChange", "onValueChange", "plugins", "primary", "rawPlugins", "readOnly", "renderElement", "renderLeaf", "value", "versionDecorate", "versionEditor", "versionSelection"]);
  return (0, import_jotai_x.createAtomStore)(__spreadValues({
    decorate: decorate,
    editor: editor,
    editorRef: editorRef,
    id: id,
    isMounted: isMounted,
    onChange: onChange,
    onSelectionChange: onSelectionChange,
    onValueChange: onValueChange,
    plugins: plugins,
    primary: primary,
    rawPlugins: rawPlugins,
    readOnly: readOnly,
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    value: value,
    versionDecorate: versionDecorate,
    versionEditor: versionEditor,
    versionSelection: versionSelection
  }, state), {
    extend: function extend(atoms) {
      return {
        trackedEditor: (0, import_jotai4.atom)(function (get) {
          return {
            editor: get(atoms.editor),
            version: get(atoms.versionEditor)
          };
        }),
        trackedSelection: (0, import_jotai4.atom)(function (get) {
          return {
            selection: get(atoms.editor).selection,
            version: get(atoms.versionSelection)
          };
        })
      };
    },
    name: "plate"
  });
};
var _createPlateStore2 = _createPlateStore(),
  _PlateStoreProvider = _createPlateStore2.PlateProvider,
  _plateStore = _createPlateStore2.plateStore,
  _usePlateStore = _createPlateStore2.usePlateStore;
var _usePlateEditorStore = function _usePlateEditorStore(id) {
  var _ref27 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref27$debugHookName = _ref27.debugHookName,
    debugHookName = _ref27$debugHookName === void 0 ? "usePlateEditorStore" : _ref27$debugHookName;
  var _a;
  var localStore = (_a = _usePlateStore(id).store({
    warnIfNoStore: false
  })) != null ? _a : null;
  var _import_react9$defaul = import_react9.default.useState(!!localStore),
    _import_react9$defaul2 = _slicedToArray(_import_react9$defaul, 1),
    localStoreExists = _import_react9$defaul2[0];
  var store = localStoreExists ? localStore :
  // eslint-disable-next-line react-hooks/rules-of-hooks
  _usePlateControllerEditorStore(id);
  var plateControllerExists = _usePlateControllerExists();
  var fallbackStore = import_react9.default.useMemo(function () {
    return (0, import_jotai4.createStore)();
  }, []);
  if (!store) {
    if (plateControllerExists) {
      return fallbackStore;
    }
    throw new Error("".concat(debugHookName, " must be used inside a Plate or PlateController"));
  }
  return store;
};
var _usePlateSelectors = function _usePlateSelectors(id, options) {
  var store = _usePlateEditorStore(id, __spreadValues({
    debugHookName: "usePlateSelectors"
  }, options));
  return _usePlateStore({
    store: store
  }).get;
};
var _usePlateActions = function _usePlateActions(id, options) {
  var store = _usePlateEditorStore(id, __spreadValues({
    debugHookName: "usePlateActions"
  }, options));
  return _usePlateStore({
    store: store
  }).set;
};
var _usePlateStates = function _usePlateStates(id, options) {
  var store = _usePlateEditorStore(id, __spreadValues({
    debugHookName: "usePlateStates"
  }, options));
  return _usePlateStore({
    store: store
  }).use;
};
var _usePlateId = function _usePlateId() {
  return _usePlateSelectors(void 0, {
    debugHookName: "usePlateId"
  }).id();
};

// src/client/stores/plate/actions/useIncrementVersion.ts
var import_react10 = __toESM(require("react"));
var _useIncrementVersion = function _useIncrementVersion(key, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var previousVersionRef = import_react10.default.useRef(1);
  var set = _usePlateActions(id, __spreadValues({
    debugHookName: "useIncrementVersion"
  }, options))[key]();
  return import_react10.default.useCallback(function () {
    var nextVersion = previousVersionRef.current + 1;
    set(nextVersion);
    previousVersionRef.current = nextVersion;
  }, [set]);
};

// src/client/stores/plate/actions/useRedecorate.ts
var import_react11 = __toESM(require("react"));
var _useRedecorate = function _useRedecorate(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var updateDecorate = _useIncrementVersion("versionDecorate", id, __spreadValues({
    debugHookName: "useRedecorate"
  }, options));
  return import_react11.default.useCallback(function () {
    updateDecorate();
  }, [updateDecorate]);
};

// src/client/stores/plate/actions/useReplaceEditor.ts
var import_react13 = __toESM(require("react"));

// src/client/stores/plate/selectors/useEditorMounted.ts
var _useEditorMounted = function _useEditorMounted(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return !!_usePlateSelectors(id, __spreadValues({
    debugHookName: "useEditorMounted"
  }, options)).isMounted();
};

// src/client/stores/plate/selectors/useEditorReadOnly.ts
var _useEditorReadOnly = function _useEditorReadOnly(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return !!_usePlateSelectors(id, __spreadValues({
    debugHookName: "useEditorReadOnly"
  }, options)).readOnly();
};

// src/client/stores/plate/selectors/useEditorRef.ts
var _useEditorRef = function _useEditorRef(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _usePlateSelectors(id, __spreadValues({
    debugHookName: "useEditorRef"
  }, options)).editor();
};

// src/client/stores/plate/selectors/useEditorSelection.ts
var _useEditorSelection = function _useEditorSelection(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _usePlateSelectors(id, __spreadValues({
    debugHookName: "useEditorSelection"
  }, options)).trackedSelection().selection;
};

// src/client/stores/plate/selectors/useEditorSelector.ts
var import_react12 = __toESM(require("react"));
var import_utils8 = require("jotai/utils");
var _useEditorSelector = function _useEditorSelector(selector, deps) {
  var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _b = _a,
    _b$equalityFn = _b.equalityFn,
    equalityFn = _b$equalityFn === void 0 ? function (a, b) {
      return a === b;
    } : _b$equalityFn,
    id = _b.id,
    storeOptions = __objRest(_b, ["equalityFn", "id"]);
  var selectorAtom = import_react12.default.useMemo(function () {
    return (0, import_utils8.selectAtom)(_plateStore.atom.trackedEditor, function (_ref28, prev) {
      var editor = _ref28.editor;
      return selector(editor, prev);
    }, equalityFn);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  return _usePlateSelectors(id, __spreadValues({
    debugHookName: "useEditorSelector"
  }, storeOptions)).atom(selectorAtom);
};

// src/client/stores/plate/selectors/useEditorState.ts
var _useEditorState = function _useEditorState(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _usePlateSelectors(id, __spreadValues({
    debugHookName: "useEditorState"
  }, options)).trackedEditor().editor;
};

// src/client/stores/plate/selectors/useEditorVersion.ts
var _useEditorVersion = function _useEditorVersion(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _usePlateSelectors(id, __spreadValues({
    debugHookName: "useEditorVersion"
  }, options)).versionEditor();
};

// src/client/stores/plate/selectors/useSelectionVersion.ts
var _useSelectionVersion = function _useSelectionVersion(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _usePlateSelectors(id, __spreadValues({
    debugHookName: "useSelectionVersion"
  }, options)).versionSelection();
};

// src/client/stores/plate/actions/useReplaceEditor.ts
var _useReplaceEditor = function _useReplaceEditor(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var editor = _useEditorRef(id, __spreadValues({
    debugHookName: "useReplaceEditor"
  }, options));
  var setEditor = _usePlateActions(id, __spreadValues({
    debugHookName: "useReplaceEditor"
  }, options)).editor();
  return import_react13.default.useCallback(function () {
    var newEditor = _createPlateEditor({
      // disable core plugins as it's already included
      disableCorePlugins: true,
      id: editor.id,
      plugins: editor.plugins
    });
    setEditor(newEditor);
  }, [editor, setEditor]);
};

// src/client/stores/event-editor/selectors/useEventPlateId.ts
var _useEventPlateId = function _useEventPlateId(id) {
  var _a;
  var focus = _useEventEditorSelectors.focus();
  var blur = _useEventEditorSelectors.blur();
  var last = _useEventEditorSelectors.last();
  var providerId = _usePlateSelectors().id();
  if (id) return id;
  if (focus) return focus;
  if (blur) return blur;
  return (_a = last != null ? last : providerId) != null ? _a : _PLATE_SCOPE;
};

// src/client/components/EditorMethodsEffect.ts
var _EditorMethodsEffect = function _EditorMethodsEffect(_ref29) {
  var id = _ref29.id;
  var editor = _useEditorRef(id);
  var redecorate = _useRedecorate(id);
  var plateStore2 = _usePlateStore(id);
  var storeSetters = Object.fromEntries(_EXPOSED_STORE_KEYS.map(function (key) {
    return [key, plateStore2.set[key]()];
  }));
  var memorizedStoreSetters = import_react14.default.useMemo(function () {
    return storeSetters;
  }, []);
  import_react14.default.useEffect(function () {
    editor.redecorate = redecorate;
    editor.plate = {
      set: memorizedStoreSetters
    };
  }, [editor, redecorate, memorizedStoreSetters]);
  return null;
};

// src/client/components/EditorRefEffect.tsx
var import_react15 = __toESM(require("react"));
function _EditorRefPluginEffect(_ref30) {
  var id = _ref30.id,
    plugin = _ref30.plugin;
  var _a;
  var editor = _useEditorRef(id);
  (_a = plugin.useHooks) == null ? void 0 : _a.call(plugin, editor, plugin);
  return null;
}
function _EditorRefEffect(_ref31) {
  var id = _ref31.id;
  var setIsMounted = _usePlateActions(id).isMounted();
  var plugins = _usePlateSelectors(id).plugins();
  var editorState = _useEditorRef(id);
  var editorRef = _usePlateSelectors(id).editorRef();
  import_react15.default.useEffect(function () {
    setIsMounted(true);
    return function () {
      setIsMounted(false);
    };
  }, [setIsMounted]);
  import_react15.default.useEffect(function () {
    if (typeof editorRef === "function") {
      editorRef(editorState);
      return function () {
        return editorRef(null);
      };
    }
    if (editorRef) {
      editorRef.current = editorState;
      return function () {
        editorRef.current = null;
      };
    }
  }, [editorRef, editorState]);
  return /* @__PURE__ */import_react15.default.createElement(import_react15.default.Fragment, null, plugins.map(function (plugin) {
    return /* @__PURE__ */import_react15.default.createElement(_EditorRefPluginEffect, {
      id: id,
      key: plugin.key,
      plugin: plugin
    });
  }));
}

// src/client/components/EditorStateEffect.tsx
var import_react16 = __toESM(require("react"));
var import_slate10 = require("slate");
var import_slate_react6 = require("slate-react");
var _EditorStateEffect = import_react16.default.memo(function (_ref32) {
  var id = _ref32.id;
  var editorState = (0, import_slate_react6.useSlate)();
  var updateVersionEditor = _useIncrementVersion("versionEditor", id);
  import_react16.default.useEffect(function () {
    updateVersionEditor();
  });
  var updateVersionSelection = _useIncrementVersion("versionSelection", id);
  var prevSelectionRef = import_react16.default.useRef(editorState.selection);
  var sameSelection = isSelectionEqual(prevSelectionRef.current, editorState.selection);
  import_react16.default.useEffect(function () {
    if (!sameSelection) {
      updateVersionSelection();
    }
    prevSelectionRef.current = editorState.selection;
  }, [editorState.selection, sameSelection, updateVersionSelection]);
  return null;
});
var isSelectionEqual = function isSelectionEqual(a, b) {
  if (!a && !b) return true;
  if (!a || !b) return false;
  return import_slate10.Range.equals(a, b);
};

// src/client/components/Plate.tsx
var import_react21 = __toESM(require("react"));
var import_slate11 = require("@udecode/slate");
var import_non_secure = require("nanoid/non-secure");

// src/client/components/PlateEffects.tsx
var import_react20 = __toESM(require("react"));

// src/client/hooks/useEditableProps.ts
var import_react17 = __toESM(require("react"));
var import_utils10 = require("@udecode/utils");
var import_omit = __toESM(require("lodash/omit.js"));
var import_use_deep_compare = require("use-deep-compare");
var _useEditableProps = function _useEditableProps() {
  var editableProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = editableProps.id;
  var editor = _useEditorRef(id);
  var selectors = _usePlateSelectors(id);
  var versionDecorate = selectors.versionDecorate();
  var readOnly = selectors.readOnly();
  var storeDecorate = selectors.decorate();
  var storeRenderLeaf = selectors.renderLeaf();
  var storeRenderElement = selectors.renderElement();
  var decorateMemo = import_react17.default.useMemo(function () {
    return _pipeDecorate(editor, storeDecorate != null ? storeDecorate : editableProps == null ? void 0 : editableProps.decorate);
  }, [editableProps == null ? void 0 : editableProps.decorate, editor, storeDecorate]);
  var decorate = import_react17.default.useMemo(function () {
    if (!versionDecorate || !decorateMemo) return;
    return function (entry) {
      return decorateMemo(entry);
    };
  }, [decorateMemo, versionDecorate]);
  var renderElement = import_react17.default.useMemo(function () {
    return _pipeRenderElement(editor, storeRenderElement != null ? storeRenderElement : editableProps == null ? void 0 : editableProps.renderElement);
  }, [editableProps == null ? void 0 : editableProps.renderElement, editor, storeRenderElement]);
  var renderLeaf = import_react17.default.useMemo(function () {
    return _pipeRenderLeaf(editor, storeRenderLeaf != null ? storeRenderLeaf : editableProps == null ? void 0 : editableProps.renderLeaf);
  }, [editableProps == null ? void 0 : editableProps.renderLeaf, editor, storeRenderLeaf]);
  var props = (0, import_use_deep_compare.useDeepCompareMemo)(function () {
    var _props = {
      decorate: decorate,
      renderElement: renderElement,
      renderLeaf: renderLeaf
    };
    if ((0, import_utils10.isDefined)(readOnly)) {
      _props.readOnly = readOnly;
    }
    _DOM_HANDLERS.forEach(function (handlerKey) {
      var handler = _pipeHandler(editor, {
        editableProps: editableProps,
        handlerKey: handlerKey
      });
      if (handler) {
        _props[handlerKey] = handler;
      }
    });
    return _props;
  }, [decorate, editableProps, renderElement, renderLeaf, readOnly]);
  return (0, import_use_deep_compare.useDeepCompareMemo)(function () {
    return __spreadValues(__spreadValues({}, (0, import_omit.default)(editableProps, [].concat(_DOM_HANDLERS, ["renderElement", "renderLeaf"]))), props);
  }, [editableProps, props]);
};

// src/client/hooks/usePlateEffects.ts
var import_react18 = __toESM(require("react"));
var import_utils11 = require("@udecode/utils");
var _usePlateEffects = function _usePlateEffects(_ref33) {
  var disableCorePlugins = _ref33.disableCorePlugins,
    id = _ref33.id,
    pluginsProp = _ref33.plugins;
  var editor = _useEditorRef(id);
  var states = _usePlateStates(id);
  var _states$rawPlugins = states.rawPlugins(),
    _states$rawPlugins2 = _slicedToArray(_states$rawPlugins, 2),
    rawPlugins = _states$rawPlugins2[0],
    setRawPlugins = _states$rawPlugins2[1];
  var _states$plugins = states.plugins(),
    _states$plugins2 = _slicedToArray(_states$plugins, 2),
    setPlugins = _states$plugins2[1];
  import_react18.default.useEffect(function () {
    if ((0, import_utils11.isDefined)(pluginsProp) && pluginsProp !== rawPlugins) {
      setRawPlugins(rawPlugins);
      _setPlatePlugins(editor, {
        disableCorePlugins: disableCorePlugins,
        plugins: pluginsProp
      });
      setPlugins(editor.plugins);
    }
  }, [disableCorePlugins, editor, rawPlugins, pluginsProp, setPlugins, setRawPlugins]);
};

// src/client/hooks/useSlateProps.ts
var import_react19 = __toESM(require("react"));
var _useSlateProps = function _useSlateProps(_ref34) {
  var id = _ref34.id;
  var editor = _useEditorRef(id);
  var value = _usePlateSelectors(id).value();
  var setValue = _usePlateActions(id).value();
  var onChangeProp = _usePlateSelectors(id).onChange();
  var onValueChangeProp = _usePlateSelectors(id).onValueChange();
  var onSelectionChangeProp = _usePlateSelectors(id).onSelectionChange();
  var onChange = import_react19.default.useCallback(function (newValue) {
    var eventIsHandled = _pipeOnChange(editor)(newValue);
    if (!eventIsHandled) {
      onChangeProp == null ? void 0 : onChangeProp(newValue);
    }
    setValue(newValue);
  }, [editor, setValue, onChangeProp]);
  var onValueChange = import_react19.default.useMemo(function () {
    return onValueChangeProp;
  }, [onValueChangeProp]);
  var onSelectionChange = import_react19.default.useMemo(function () {
    return onSelectionChangeProp;
  }, [onSelectionChangeProp]);
  return import_react19.default.useMemo(function () {
    return {
      editor: editor,
      initialValue: value,
      key: editor.key,
      onChange: onChange,
      onSelectionChange: onSelectionChange,
      onValueChange: onValueChange,
      value: value
    };
  }, [editor, onChange, onSelectionChange, onValueChange, value]);
};

// src/client/components/PlateEffects.tsx
function _PlateEffects(_a) {
  var _b = _a,
    children = _b.children,
    props = __objRest(_b, ["children"]);
  _usePlateEffects(props);
  return /* @__PURE__ */import_react20.default.createElement(import_react20.default.Fragment, null, children);
}

// src/client/components/Plate.tsx
function PlateInner(_ref35) {
  var children = _ref35.children,
    decorate = _ref35.decorate,
    disableCorePlugins = _ref35.disableCorePlugins,
    editorProp = _ref35.editor,
    editorRef = _ref35.editorRef,
    idProp = _ref35.id,
    initialValue = _ref35.initialValue,
    maxLength = _ref35.maxLength,
    shouldNormalizeInitialValue = _ref35.normalizeInitialValue,
    onChange = _ref35.onChange,
    onSelectionChange = _ref35.onSelectionChange,
    onValueChange = _ref35.onValueChange,
    pluginsProp = _ref35.plugins,
    primary = _ref35.primary,
    readOnly = _ref35.readOnly,
    renderElement = _ref35.renderElement,
    renderLeaf = _ref35.renderLeaf,
    valueProp = _ref35.value;
  var _import_react21$defau = import_react21.default.useState(function () {
      var _a, _b;
      return (_b = (_a = editorProp == null ? void 0 : editorProp.id) != null ? _a : idProp) != null ? _b : (0, import_non_secure.nanoid)();
    }),
    _import_react21$defau2 = _slicedToArray(_import_react21$defau, 1),
    id = _import_react21$defau2[0];
  var editor = import_react21.default.useMemo(function () {
    return editorProp != null ? editorProp : _createPlateEditor({
      disableCorePlugins: disableCorePlugins,
      id: id,
      maxLength: maxLength,
      plugins: pluginsProp
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var value = import_react21.default.useMemo(function () {
    var currValue = initialValue != null ? initialValue : valueProp;
    if (!currValue) {
      currValue = editor.children.length > 0 ? editor.children : editor.childrenFactory();
    }
    var normalizedValue = _normalizeInitialValue(editor, currValue);
    if (normalizedValue) {
      currValue = normalizedValue;
    }
    editor.children = currValue;
    if (shouldNormalizeInitialValue) {
      (0, import_slate11.normalizeEditor)(editor, {
        force: true
      });
    }
    return editor.children;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return /* @__PURE__ */import_react21.default.createElement(_PlateStoreProvider, {
    decorate: decorate,
    editor: editor,
    editorRef: editorRef,
    id: id,
    onChange: onChange,
    onSelectionChange: onSelectionChange,
    onValueChange: onValueChange,
    plugins: editor.plugins,
    primary: primary,
    rawPlugins: pluginsProp,
    readOnly: readOnly,
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    scope: id,
    value: value
  }, /* @__PURE__ */import_react21.default.createElement(_PlateEffects, {
    disableCorePlugins: disableCorePlugins,
    id: id,
    plugins: pluginsProp
  }, children));
}
function _Plate(props) {
  var id = props.id;
  return /* @__PURE__ */import_react21.default.createElement(PlateInner, __spreadValues({
    key: id == null ? void 0 : id.toString()
  }, props));
}

// src/client/components/PlateContent.tsx
var import_react24 = __toESM(require("react"));
var import_slate_react9 = require("slate-react");

// src/client/components/PlateControllerEffect.ts
var import_react22 = __toESM(require("react"));
var import_jotai_optics = require("jotai-optics");
var import_slate_react7 = require("slate-react");
var _PlateControllerEffect = function _PlateControllerEffect(_ref36) {
  var idProp = _ref36.id;
  var idFromStore = _usePlateId();
  var id = idProp != null ? idProp : idFromStore;
  var currentStoreAtom = import_react22.default.useMemo(function () {
    return (0, import_jotai_optics.focusAtom)(_plateControllerStore.atom.editorStores, function (optic) {
      return optic.prop(id);
    });
  }, [id]);
  var setCurrentStore = _usePlateControllerActions().atom(currentStoreAtom, {
    warnIfNoStore: false
  });
  var store = _usePlateStore(id).store();
  var primary = _usePlateSelectors(id).primary();
  var setPrimaryEditorIds = _usePlateControllerActions().primaryEditorIds({
    warnIfNoStore: false
  });
  var focused = (0, import_slate_react7.useFocused)();
  var setActiveId = _usePlateControllerActions().activeId({
    warnIfNoStore: false
  });
  import_react22.default.useEffect(function () {
    setCurrentStore(store != null ? store : null);
    return function () {
      setCurrentStore(null);
      setActiveId(function (activeId) {
        return activeId === id ? null : activeId;
      });
    };
  }, [store, setCurrentStore, setActiveId, id]);
  import_react22.default.useEffect(function () {
    if (primary) {
      setPrimaryEditorIds(function (ids) {
        return [].concat(_toConsumableArray(ids), [id]);
      });
      return function () {
        setPrimaryEditorIds(function (ids) {
          return ids.filter(function (i) {
            return i !== id;
          });
        });
      };
    }
  }, [id, primary, setPrimaryEditorIds]);
  import_react22.default.useEffect(function () {
    if (id && focused) {
      setActiveId(id);
    }
  }, [id, focused, setActiveId]);
  return null;
};

// src/client/components/PlateSlate.tsx
var import_react23 = __toESM(require("react"));
var import_slate_react8 = require("slate-react");
function _PlateSlate(_ref37) {
  var children = _ref37.children,
    id = _ref37.id;
  var _a;
  var slateProps = _useSlateProps({
    id: id
  });
  var editor = _useEditorRef(id);
  var aboveSlate = /* @__PURE__ */import_react23.default.createElement(import_slate_react8.Slate, __spreadValues({}, slateProps), children);
  (_a = editor.plugins) == null ? void 0 : _a.forEach(function (plugin) {
    var RenderAboveSlate = plugin.renderAboveSlate;
    if (RenderAboveSlate) aboveSlate = /* @__PURE__ */import_react23.default.createElement(RenderAboveSlate, null, aboveSlate);
  });
  return aboveSlate;
}

// src/client/components/PlateContent.tsx
var _PlateContent = import_react24.default.forwardRef(function (_a, ref) {
  var _b = _a,
    renderEditable = _b.renderEditable,
    props = __objRest(_b, ["renderEditable"]);
  var id = props.id;
  var editor = _useEditorRef(id);
  if (!editor) {
    throw new Error("Editor not found. Please ensure that PlateContent is rendered below Plate.");
  }
  var editableProps = _useEditableProps(props);
  var editable = /* @__PURE__ */import_react24.default.createElement(import_slate_react9.Editable, __spreadValues({
    ref: ref
  }, editableProps));
  var afterEditable = null;
  var beforeEditable = null;
  editor.plugins.forEach(function (plugin) {
    var RenderAfterEditable = plugin.renderAfterEditable,
      RenderBeforeEditable = plugin.renderBeforeEditable;
    if (RenderAfterEditable) {
      afterEditable = /* @__PURE__ */import_react24.default.createElement(import_react24.default.Fragment, null, afterEditable, /* @__PURE__ */import_react24.default.createElement(RenderAfterEditable, __spreadValues({}, editableProps)));
    }
    if (RenderBeforeEditable) {
      beforeEditable = /* @__PURE__ */import_react24.default.createElement(import_react24.default.Fragment, null, beforeEditable, /* @__PURE__ */import_react24.default.createElement(RenderBeforeEditable, __spreadValues({}, editableProps)));
    }
  });
  var aboveEditable = /* @__PURE__ */import_react24.default.createElement(import_react24.default.Fragment, null, beforeEditable, renderEditable ? renderEditable(editable) : editable, /* @__PURE__ */import_react24.default.createElement(_EditorMethodsEffect, {
    id: id
  }), /* @__PURE__ */import_react24.default.createElement(_EditorStateEffect, {
    id: id
  }), /* @__PURE__ */import_react24.default.createElement(_EditorRefEffect, {
    id: id
  }), /* @__PURE__ */import_react24.default.createElement(_PlateControllerEffect, {
    id: id
  }), afterEditable);
  editor.plugins.forEach(function (plugin) {
    var RenderAboveEditable = plugin.renderAboveEditable;
    if (RenderAboveEditable) aboveEditable = /* @__PURE__ */import_react24.default.createElement(RenderAboveEditable, null, aboveEditable);
  });
  return /* @__PURE__ */import_react24.default.createElement(_PlateSlate, {
    id: id
  }, aboveEditable);
});
_PlateContent.displayName = "PlateContent";

// src/client/components/PlateTest.tsx
var import_react25 = __toESM(require("react"));
function _PlateTest(_a) {
  var _b = _a,
    editableProps = _b.editableProps,
    normalizeInitialValue2 = _b.normalizeInitialValue,
    _b$variant = _b.variant,
    variant = _b$variant === void 0 ? "wordProcessor" : _b$variant,
    props = __objRest(_b, ["editableProps", "normalizeInitialValue", "variant"]);
  var _editor = props.editor,
    id = props.id,
    plugins = props.plugins;
  var editor = _editor;
  if (editor && !editor.plugins) {
    editor = _createPlateEditor({
      editor: editor,
      id: id,
      normalizeInitialValue: normalizeInitialValue2,
      plugins: plugins
    });
  }
  return /* @__PURE__ */import_react25.default.createElement(_Plate, __spreadProps(__spreadValues({}, props), {
    editor: editor
  }), /* @__PURE__ */import_react25.default.createElement(_PlateContent, __spreadValues({
    autoFocus: true,
    "data-testid": "slate-content-editable",
    "data-variant": variant
  }, editableProps)));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BLUR_EDITOR_EVENT: _BLUR_EDITOR_EVENT,
  CARRIAGE_RETURN: _CARRIAGE_RETURN,
  DOM_HANDLERS: _DOM_HANDLERS,
  DefaultLeaf: _DefaultLeaf,
  ELEMENT_DEFAULT: _ELEMENT_DEFAULT,
  EXPOSED_STORE_KEYS: _EXPOSED_STORE_KEYS,
  EditorMethodsEffect: _EditorMethodsEffect,
  EditorRefEffect: _EditorRefEffect,
  EditorRefPluginEffect: _EditorRefPluginEffect,
  EditorStateEffect: _EditorStateEffect,
  ElementProvider: _ElementProvider,
  FOCUS_EDITOR_EVENT: _FOCUS_EDITOR_EVENT,
  GLOBAL_PLATE_SCOPE: _GLOBAL_PLATE_SCOPE,
  Hotkeys: _Hotkeys,
  KEY_DESERIALIZE_AST: _KEY_DESERIALIZE_AST,
  KEY_DESERIALIZE_HTML: _KEY_DESERIALIZE_HTML,
  KEY_EDITOR_PROTOCOL: _KEY_EDITOR_PROTOCOL,
  KEY_EVENT_EDITOR: _KEY_EVENT_EDITOR,
  KEY_HISTORY: _KEY_HISTORY,
  KEY_INLINE_VOID: _KEY_INLINE_VOID,
  KEY_INSERT_DATA: _KEY_INSERT_DATA,
  KEY_LENGTH: _KEY_LENGTH,
  KEY_NODE_FACTORY: _KEY_NODE_FACTORY,
  KEY_PREV_SELECTION: _KEY_PREV_SELECTION,
  KEY_REACT: _KEY_REACT,
  LINE_FEED: _LINE_FEED,
  NO_BREAK_SPACE: _NO_BREAK_SPACE,
  PLATE_SCOPE: _PLATE_SCOPE,
  Plate: _Plate,
  PlateContent: _PlateContent,
  PlateController: _PlateController,
  PlateControllerEffect: _PlateControllerEffect,
  PlateEffects: _PlateEffects,
  PlateSlate: _PlateSlate,
  PlateStoreProvider: _PlateStoreProvider,
  PlateTest: _PlateTest,
  SCOPE_ELEMENT: _SCOPE_ELEMENT,
  SPACE: _SPACE,
  TAB: _TAB,
  ZERO_WIDTH_SPACE: _ZERO_WIDTH_SPACE,
  applyDeepToNodes: _applyDeepToNodes2,
  atom: atom,
  cleanHtmlBrElements: _cleanHtmlBrElements,
  cleanHtmlCrLf: _cleanHtmlCrLf,
  cleanHtmlEmptyElements: _cleanHtmlEmptyElements,
  cleanHtmlFontElements: _cleanHtmlFontElements,
  cleanHtmlLinkElements: _cleanHtmlLinkElements,
  cleanHtmlTextNodes: _cleanHtmlTextNodes,
  collapseString: _collapseString,
  collapseWhiteSpace: _collapseWhiteSpace,
  collapseWhiteSpaceChildren: _collapseWhiteSpaceChildren,
  collapseWhiteSpaceElement: _collapseWhiteSpaceElement,
  collapseWhiteSpaceNode: _collapseWhiteSpaceNode,
  collapseWhiteSpaceText: _collapseWhiteSpaceText,
  convertDomEventToSyntheticEvent: _convertDomEventToSyntheticEvent,
  copyBlockMarksToSpanChild: _copyBlockMarksToSpanChild,
  createAtomStore: createAtomStore,
  createDeserializeAstPlugin: _createDeserializeAstPlugin,
  createDeserializeHtmlPlugin: _createDeserializeHtmlPlugin,
  createEditorProtocolPlugin: _createEditorProtocolPlugin,
  createEventEditorPlugin: _createEventEditorPlugin,
  createHistoryPlugin: _createHistoryPlugin,
  createHotkey: _createHotkey,
  createInlineVoidPlugin: _createInlineVoidPlugin,
  createInsertDataPlugin: _createInsertDataPlugin,
  createLengthPlugin: _createLengthPlugin,
  createNodeFactoryPlugin: _createNodeFactoryPlugin,
  createPlateEditor: _createPlateEditor,
  createPlateFallbackEditor: _createPlateFallbackEditor,
  createPlateStore: _createPlateStore,
  createPluginFactory: _createPluginFactory,
  createPlugins: _createPlugins,
  createPrevSelectionPlugin: _createPrevSelectionPlugin,
  createReactPlugin: _createReactPlugin,
  createZustandStore: createZustandStore,
  deserializeHtml: _deserializeHtml,
  deserializeHtmlElement: _deserializeHtmlElement,
  deserializeHtmlNode: _deserializeHtmlNode,
  deserializeHtmlNodeChildren: _deserializeHtmlNodeChildren,
  endInlineFormattingContext: _endInlineFormattingContext,
  eventEditorActions: _eventEditorActions,
  eventEditorSelectors: _eventEditorSelectors,
  eventEditorStore: _eventEditorStore,
  findHtmlElement: _findHtmlElement,
  flattenDeepPlugins: _flattenDeepPlugins2,
  getEventPlateId: _getEventPlateId,
  getHtmlComments: _getHtmlComments,
  getInjectedPlugins: _getInjectedPlugins,
  getKeyByType: _getKeyByType,
  getKeysByTypes: _getKeysByTypes,
  getPlugin: _getPlugin,
  getPluginInjectProps: _getPluginInjectProps,
  getPluginOptions: _getPluginOptions,
  getPluginType: _getPluginType,
  getPluginTypes: _getPluginTypes,
  getPlugins: _getPlugins,
  getPluginsByKey: _getPluginsByKey,
  getRenderNodeProps: _getRenderNodeProps,
  getSlateClass: _getSlateClass,
  htmlBodyToFragment: _htmlBodyToFragment,
  htmlBrToNewLine: _htmlBrToNewLine,
  htmlElementToElement: _htmlElementToElement,
  htmlElementToLeaf: _htmlElementToLeaf,
  htmlStringToDOMNode: _htmlStringToDOMNode,
  htmlTextNodeToString: _htmlTextNodeToString,
  inferWhiteSpaceRule: _inferWhiteSpaceRule,
  inlineTagNames: _inlineTagNames,
  isEventHandled: _isEventHandled,
  isHotkey: isHotkey,
  isHotkeyPressed: isHotkeyPressed,
  isHtmlBlockElement: _isHtmlBlockElement,
  isHtmlComment: _isHtmlComment,
  isHtmlElement: _isHtmlElement,
  isHtmlFragmentHref: _isHtmlFragmentHref,
  isHtmlInlineElement: _isHtmlInlineElement2,
  isHtmlTable: _isHtmlTable,
  isHtmlText: _isHtmlText,
  isLastNonEmptyTextOfInlineFormattingContext: _isLastNonEmptyTextOfInlineFormattingContext,
  isOlSymbol: _isOlSymbol,
  mapInjectPropsToPlugin: _mapInjectPropsToPlugin,
  mergeDeepPlugins: _mergeDeepPlugins2,
  mergeDeepToNodes: _mergeDeepToNodes,
  mockPlugin: _mockPlugin,
  nanoid: nanoid,
  normalizeDescendantsToDocumentFragment: _normalizeDescendantsToDocumentFragment,
  normalizeInitialValue: _normalizeInitialValue,
  overridePluginsByKey: _overridePluginsByKey2,
  parseHtmlDocument: _parseHtmlDocument,
  parseHtmlElement: _parseHtmlElement,
  pipeDecorate: _pipeDecorate,
  pipeDeserializeHtmlElement: _pipeDeserializeHtmlElement,
  pipeDeserializeHtmlLeaf: _pipeDeserializeHtmlLeaf,
  pipeHandler: _pipeHandler,
  pipeInjectProps: _pipeInjectProps,
  pipeInsertDataQuery: _pipeInsertDataQuery,
  pipeInsertFragment: _pipeInsertFragment,
  pipeOnChange: _pipeOnChange,
  pipeRenderElement: _pipeRenderElement,
  pipeRenderLeaf: _pipeRenderLeaf,
  pipeTransformData: _pipeTransformData,
  pipeTransformFragment: _pipeTransformFragment,
  plateControllerStore: _plateControllerStore,
  plateStore: _plateStore,
  pluginDeserializeHtml: _pluginDeserializeHtml,
  pluginInjectProps: _pluginInjectProps,
  pluginRenderElement: _pluginRenderElement,
  pluginRenderLeaf: _pluginRenderLeaf,
  postCleanHtml: _postCleanHtml,
  preCleanHtml: _preCleanHtml,
  removeHtmlNodesBetweenComments: _removeHtmlNodesBetweenComments,
  removeHtmlSurroundings: _removeHtmlSurroundings,
  replaceTagName: _replaceTagName,
  resetEditor: _resetEditor,
  resetEditorChildren: _resetEditorChildren,
  setDefaultPlugin: _setDefaultPlugin,
  setPlatePlugins: _setPlatePlugins,
  sharedHotkeys: _sharedHotkeys,
  someHtmlElement: _someHtmlElement,
  toggleNodeType: _toggleNodeType,
  traverseHtmlComments: _traverseHtmlComments,
  traverseHtmlElements: _traverseHtmlElements,
  traverseHtmlNode: _traverseHtmlNode2,
  traverseHtmlTexts: _traverseHtmlTexts,
  unwrapHtmlElement: _unwrapHtmlElement,
  upsertInlineFormattingContext: _upsertInlineFormattingContext,
  useEditableProps: _useEditableProps,
  useEditorMounted: _useEditorMounted,
  useEditorReadOnly: _useEditorReadOnly,
  useEditorRef: _useEditorRef,
  useEditorSelection: _useEditorSelection,
  useEditorSelector: _useEditorSelector,
  useEditorState: _useEditorState,
  useEditorVersion: _useEditorVersion,
  useElement: _useElement,
  useElementStore: _useElementStore,
  useEventEditorSelectors: _useEventEditorSelectors,
  useEventPlateId: _useEventPlateId,
  useFocusEditorEvents: _useFocusEditorEvents,
  useHotkeys: useHotkeys,
  useIncrementVersion: _useIncrementVersion,
  usePlateActions: _usePlateActions,
  usePlateControllerActions: _usePlateControllerActions,
  usePlateControllerEditorStore: _usePlateControllerEditorStore,
  usePlateControllerExists: _usePlateControllerExists,
  usePlateControllerSelectors: _usePlateControllerSelectors,
  usePlateControllerStates: _usePlateControllerStates,
  usePlateControllerStore: _usePlateControllerStore,
  usePlateEditorStore: _usePlateEditorStore,
  usePlateEffects: _usePlateEffects,
  usePlateId: _usePlateId,
  usePlateSelectors: _usePlateSelectors,
  usePlateStates: _usePlateStates,
  usePlateStore: _usePlateStore,
  useRedecorate: _useRedecorate,
  useReplaceEditor: _useReplaceEditor,
  useSelectionVersion: _useSelectionVersion,
  useSlateProps: _useSlateProps,
  withEditorProtocol: _withEditorProtocol,
  withHOC: _withHOC,
  withInlineVoid: _withInlineVoid,
  withInsertData: _withInsertData,
  withLength: _withLength,
  withPlate: _withPlate,
  withTHistory: _withTHistory,
  withTReact: _withTReact
});